import * as React from "react";
import * as ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { variables } from '../Variables';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { Schedular } from './Schedular';
import { Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { MultiSelect } from "react-multi-select-component";
import { setstatusfilter, clearstatusfilter } from "../features/StatusFilterSlice";
import { setagentfilter, clearagentfilter } from "../features/AgentFilterSlice";
import { setselectedproperty, clearselectedproperty } from "../features/SelectedPropertySlice";
import { setsetting, clearsetting } from "../features/SettingSlice";
import { setSidebarCollapsed } from "../features/SidebarCollapseSlice";
import { setlanguages, resetlanguages } from "../features/LanguageSlice";
import { EventModal } from "./EventModal";
import { ConfirmDeleteWindow } from "./ConfirmDeleteWindow";
import { setCalendarView } from "../features/CalendarSelectedViewSlice";
import { cleareventdetail } from "../features/CreateEventDetailSlice";
import { clearBookAbleUntil } from "../features/BookAbleUntilSlice";
import { login } from "../features/userSlice";
import { format } from 'date-fns';

import filterIcon from '../assets/images/filter-icon.svg';
import plusIcon from '../assets/images/plus.svg';
import collapseIcon from '../assets/images/collapse.svg';
import expandIcon from '../assets/images/expand.svg';
import placeholderLarge from '../assets/images/prop-placeholder-lg.jpg';
import placeholderSmall from '../assets/images/prop-placeholder-sm.jpg';
import plusBlueIcon from '../assets/images/plus_blue.svg';
import bedIcon from '../assets/images/bed-duo.svg';
import showerIcon from '../assets/images/shower-duo.svg';
import liftIcon from '../assets/images/lift-duo.svg';
import whiteCross from '../assets/images/cross_white.png';
import filterCross from '../assets/images/filter-cross.svg';
import calLoader from '../assets/images/calendar-loader.svg';
import { clearDuplicateTimeSlots } from "../features/DuplicateTimeSlotSlice";
import { clearScheduleTimeSlotDetail } from "../features/ScheduleTimeSlotDetailSlice";
import { setActiveEstateList } from "../features/ActiveEstateList";
import { ContactWaitingListModel } from "./ContactWaitingListModel";
import { addNewContactOnWhise, addWhiseCalendarEventService, checkContactStatusFromWhise, createDummpyEventObj, deletWhiseEventService, getContactDetailFromDB, isEventTimeAvailableInDB, updateEventDetailInDB } from "../utils/EventService";
import { convertTBCToConfirmedEvent, formatDateTimeLanguageSpecificService, getClientSettingService, getContactTitleListService, getEstateAndOfficeSettingAgentsite, getLatestEstateIdFromDB, getOfficeLogoService, saveAutomaticAcceptSetting, updateParentActionLog } from "../services/commonService";
import { addNewActionsLog, getEstateStatusFromInDB, titleSafeParse } from "../utils/commonService";
import { sendCalendarCreateApiErrorEmail } from "../utils/emailTempletesService";
import { EstateJobActionModel } from "../ui/EstateJobActionModel";
import { getStartingNumber } from "../utils/validate";
import { EstateActionListMenu } from "../ui/EstateActionListMenu";
import { setAllEstatesList } from "../features/AllEstatesListSlice";
import { setFetchLatestRecordStatus } from "../features/FetchLatestRecordSlice";
import { setEstateStatusList } from "../features/EstateStatusListSlice";
import { setWaitingListStatusEnabled } from "../features/WaitingListStatus";
import { setShowEditEstateConfigModal } from "../features/ShowEditEstateConfigModal";
import { setShowWaitingAndEventsModal } from "../features/ShowWaitingAndEventsModal";
import { setRenderApp } from "../features/RenderApp";

const { useState, useRef, useCallback } = React;

export const Calendar = ({ showMessage }) => {
    const user = useSelector(state => state.user.user);
    const [selected, setSelected] = useState([]);
    const [isPropertiesCollapsed, setIsPropertiesCollapsed] = useState(false);
    const [clientEstates, setClientEstates] = useState([]);
    const [filteredEstates, setFilteredEstates] = useState([]);
    const [clientToken, setClientToken] = useState('');
    const [height, setHeight] = useState(null);
    const [showHideCalendarFilter, setShowHideCalendarFilter] = useState(false);
    const [whiseAgents, setWhiseAgents] = useState([]);
    const [whiseCalendarEvents, setWhiseCalendarEvents] = useState([]);
    const [calendarEventsFromDB, setCalendarEventsFromDB] = useState([]);
    const [whiseCalendarEventId, setWhiseCalendarEventId] = useState(0);
    const [whiseContactId, setWhiseContactId] = useState(0);
    const [showModal, setShowModal] = useState(false);
    //const [officeId, setOfficeId] = useState(user.user.officeId);
    const [confirmedIds, setConfirmedIds] = useState([]);
    const [tobeConfirmedIds, setTobeConfirmedIds] = useState([]);
    const [freeSlotIds, setFreeSlotIds] = useState([]);
    const [calendarActions, setCalendarActions] = useState([]);
    const [officeSettings, setOfficeSettings] = useState({});
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [selectedAgents, setSelectedAgents] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [previewEvent, setPreviewEvent] = useState(false);
    const [showCalendarLoader, setShowCalendarLoader] = useState(true);
    const [estateId, setEstateId] = useState("");
    const [estateSearch, setEstateSearch] = useState("");
    const [purposeStatusId, setPurposeStatusId] = useState("2");
    /* const [displayStatusId, setDisplayStatusId] = useState([]);*/
    const [estateListContainEvent, setEstateListContainEvent] = useState([]);
    const [estateIdsHavingFreeSlotsInFutureOrPast, setEstateIdsHavingFreeSlotsInFutureOrPast] = useState([]);
    const [previewEventDetail, setPreviewEventDetail] = useState(null);
    const [eventToBeAccepted, setEventToBeAccepted] = useState(null);
    const [estateDetailForEventToBeAccepted, setEstateDetailForEventToBeAccepted] = useState(null);
    const [whiseOffice, setWhiseOffice] = useState(null);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [showConfirmWindow, setShowConfirmWindow] = useState(false);
    const [isDeleteConfirmed, setIsDeleteConfirmed] = useState(false);
    const [freeSlotsEstateIdToBeDeleted, setFreeSlotsEstateIdToBeDeleted] = useState(null);
    const [clickedDeleteFreeSlotButton, setClickedDeleteFreeSlotButton] = useState(null);
    const [estateIdsHavingConfiguration, setEstateIdsHavingConfiguration] = useState([]);
    const [confirmWindowMessage, setConfirmWindowMessage] = useState("Do you want to delete past free slots?");
    const [isLocalDbEventToBeDeleted, setIsLocalDbEventToBeDeleted] = useState(false);
    const [currentRange, setCurrentRange] = useState({ start: null, end: null });
    const [activatedEstates, setActivatedEstates] = useState([]);
    const [suspendedEstates, setSuspendedEstates] = useState([]);
    const [showSynchingLoader, setShowSynchingLoader] = useState(false);
    const estateDropdownManuRef = useRef(null);

    const [isEstateConfigurationsEdit, setIsEstateConfigurationsEdit] = useState(false);
    const [showPropertiesLoader, setShowPropertiesLoader] = useState(false);
    const [selectOffice, setSelectOffice] = useState("");
    const [isOfficesLoaded, setIsOfficesLoaded] = useState(false);
    const [officeList, setOfficeList] = useState([]);
    const [getAvilableEventSlotFromRedux, setGetAvilableEventSlotFromRedux] = useState(null);
    const [estateStatusListFromDB, setEstateStatusListFromDB] = useState({});
    const [waitingListEnabled, setWaitingListEnabled] = useState(false);
    const [contactWaitinglistModalShow, setContactWaitinglistModalShow] = useState(false);
    const [contactWaitingListData, setContactWaitingListData] = useState([]);

    // waiting list data grid states
    const [pageDataGrid, setPageDataGrid] = useState(0);
    const [pageSizeDataGrid, setPageSizeDataGrid] = useState(25);
    const [totalRecordDataGrid, setTotalRecordDataGrid] = useState(0);
    const [statusDataGrid, setStatusDataGrid] = useState(null);
    const [filterDataGrid, setFilterDataGrid] = useState("");
    const [filterSearchEnterkey, setFilterSearchEnterkey] = useState(false);
    const [isLoadingDataGrid, setIsLoadingDataGrid] = useState(false);
    const [contactTitlesList, setContactTitlesList] = useState([]);
    const [tabBtnActiveWaitingList, setTabBtnActiveWaitingList] = useState("1");
    const [waitingListGridAllDataFromApi, setWaitingListGridAllDataFromApi] = useState(null);
    const [waitListBtnEnabled, setWaitListBtnEnabled] = useState(false);
    const [automaticSlotAccept, setAutomaticSlotAccept] = useState("");
    const [estateJobStatusBtn, setEstateJobStatusBtn] = useState(null);
    const [showEstateJobActionModel, setShowEstateJobActionModel] = useState(false);

    const clientId = user.user.clientId;
    const officeId = user.user.officeId;
    const contactId = user.user.contactId;
    const whiseUserToken = useSelector(state => state.whiseUser.whiseToken);
    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);
    const reduxStatus = useSelector(state => state.statusFilter.statusFilter);
    const reduxAgent = useSelector(state => state.agentFilter.agentFilter);
    const reduxEventDetail = useSelector(state => state.eventDetail.eventDetail);
    const actions = useSelector(state => state.calendarActions.calendarActions);
    const reduxClientToken = useSelector(state => state.whiseClientToken.whiseClientToken);
    const reduxIsSidebarCollapsed = useSelector(state => state.isSideBarCollapsed.sidebarCollapsed);
    /*console.log(reduxEventDetail);*/
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const reduxCalendarView = useSelector(state => state.calendarView.calendarView);
    const reduxBookAbleUntil = useSelector(state => state.bookAbleUntil.bookAbleUntil);
    const reduxActiveEstateList = useSelector(state => state.activeEstateList.activeEstateList);

    const userAccountType = useSelector(state => state.userAccountType.userAccountType);
    const clientTokenByAccountType = useSelector(state => state.clientWhiseTokenByAccountType.clientWhiseTokenByAccountType);

    // Estate action list menu
    const reduxEstateStatusList = useSelector(state => state.estateStatusList.estateStatusList);
    const reduxFetchLatestRecord = useSelector(state => state.fetchLatestRecord.fetchLatestRecord);
    const reduxShowEditEstateConfigModal = useSelector(state => state.showEditEstateConfigModal.showEditEstateConfigModal);
    const reduxshowWaitingAndEventsModal = useSelector(state => state.showWaitingAndEventsModal.showWaitingAndEventsModal);
    const reduxRenderApp = useSelector(state => state.renderApp.renderApp);
    
    /*let statusesOptions =;*/
    const customMultiSelectLabels = {
        "allItemsAreSelected": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownAllItemsSelectLbl"] : "All items are selected.",
        "noOptions": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownNoOptionsLbl"] : "No options",
        "search": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSearchLbl"] : "Search",
        "selectAll": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSelectAllLbl"] : "Select All",
        "selectAllFiltered": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSelectAllFilterLbl"] : "Select All (Filtered)",
        "selectSomeItems": reduxLanguageTranslations ? reduxLanguageTranslations["multiSelectDropdownSelectLbl"] : "Select..."
    }

    const displayStatusOptions = [
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOffline"] : "Offline", value: "1" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusOnline"] : "Online", value: "2" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusMonth"] : "EstateOfTheMonth", value: "3" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusRealisations"] : "Realisations", value: "4" },
        { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusWebsite"] : "OnlineWebsiteOnly", value: "5" },
    ];

    const [displayStatusIds, setDisplayStatusIds] = useState([
        displayStatusOptions[0], // Offline
        displayStatusOptions[1], // Online
        displayStatusOptions[2], // EstateOfTheMonth
    ]);

    let container = useRef(null);
    const calendarRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClose = () => {
        setShowModal(false);
        dispatch(cleareventdetail());
        dispatch(clearBookAbleUntil());
        dispatch(clearDuplicateTimeSlots());
        dispatch(clearScheduleTimeSlotDetail());
        setTimeout(() => {
            setPreviewEvent(false);
            setIsEstateConfigurationsEdit(false);
            dispatch(setShowEditEstateConfigModal(false)); // edit estate config modal
        }, 200)
    }

    const handlerSaveFilter = (e) => {

        dispatch(setselectedproperty(selectedProperty));
        dispatch(setagentfilter(selectedAgents));
        dispatch(setstatusfilter(selectedStatuses));
        setShowHideCalendarFilter(false);
    }

    const handleCancelFilter = () => {
        setShowHideCalendarFilter(false);
    }

    const changeHandlerAgentFilter = (e) => {
        let option = e.target.selectedOptions;
        if (option[0].value != "") {
            let item = JSON.parse(option[0].dataset.agent);
            let agent = [{ label: item.name, value: item.id, agentDetail: item }];
            setSelectedAgents(agent);
        }
        else {
            setSelectedAgents([]);
        }
        //dispatch(setagentfilter(e));
    }

    const callBackToUpdateCalendarFilter = (agent) => {
        if (agent.length > 0) {
            setSelectedAgents(agent);
        }
        else {
            setSelectedAgents([]);
        }
    }

    const handlerClearCalenderFilter = (e) => {
        e.stopPropagation();
        setSelectedStatuses([]);
        setSelectedAgents([]);
        dispatch(clearstatusfilter());
        dispatch(clearagentfilter());
    }

    const handleChangeStatus = (item) => {
        setSelectedStatuses(item)
        //dispatch(setstatusfilter(item));
    }

    const getClientWhiseEstatesList = async (clientToken) => {
        var estateLimit = 300;
        var pageOffset = 0;
        let listOfEstates = [];

        let _response = await getWhiseEstatesListByPagin(clientToken, estateLimit, pageOffset);
        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEstates.push(..._response.estates);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = estateLimit * i + 1;
                let _getEstateListResponse = await getWhiseEstatesListByPagin(clientToken, estateLimit, pageOffset);
                if (_getEstateListResponse.estates.length > 0) {
                    listOfEstates.push(..._getEstateListResponse.estates);
                }
            }

            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let estatesAfterApplyingFilter = listOfEstates.filter(item => {
                return (
                    item.officeId == +selectOffice
                );
            });

            if (estateSearch != "") {
                let listAfterFirstFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemPrice = item.price != undefined ? item.price + "" : "";
                    let city = item.city != undefined ? item.city.toLowerCase() : "";
                    let address = item.address != undefined ? item.address.toLowerCase() : "";
                    let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                    let number = item.number != undefined ? item.number.toLowerCase() : "";
                    return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
                });
                estatesAfterApplyingFilter = listAfterFirstFilter;
            }
            if (estateId != "") {
                let listAfterSecondFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemEstateId = item.id + "";
                    return itemEstateId.includes(estateId);
                });
                estatesAfterApplyingFilter = listAfterSecondFilter;
            }
            if (modifyDisplayStausSelectedIds.length > 0) {
                let listAfterThirdFilter = estatesAfterApplyingFilter.filter(item =>
                    modifyDisplayStausSelectedIds.includes(item.displayStatusId)
                );
                estatesAfterApplyingFilter = listAfterThirdFilter;
            }
            if (purposeStatusId != "") {
                let filteredEstatesList = estatesAfterApplyingFilter.filter(item => {
                    return item.purpose.id == purposeStatusId;
                })
                setFilteredEstates(filteredEstatesList);
                estatesAfterApplyingFilter = filteredEstatesList;
            }

            if (listOfEstates.length > 0) {
                setClientEstates(listOfEstates);
                setFilteredEstates(estatesAfterApplyingFilter);
                getEstateStatusListFromDB(listOfEstates);
                dispatch(setAllEstatesList(listOfEstates)); // set all estate list in the redux
            }
        }
        else if (_response.estates != undefined && _response.estates.length > 0) {
            listOfEstates.push(..._response.estates);

            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let estatesAfterApplyingFilter = listOfEstates.filter(item => {
                return (
                    item.officeId == +selectOffice
                );
            });

            if (estateSearch != "") {
                let listAfterFirstFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemPrice = item.price != undefined ? item.price + "" : "";
                    let city = item.city != undefined ? item.city.toLowerCase() : "";
                    let address = item.address != undefined ? item.address.toLowerCase() : "";
                    let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                    let number = item.number != undefined ? item.number.toLowerCase() : "";
                    return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
                });
                estatesAfterApplyingFilter = listAfterFirstFilter;
            }
            if (estateId != "") {
                let listAfterSecondFilter = estatesAfterApplyingFilter.filter(item => {
                    let itemEstateId = item.id + "";
                    return itemEstateId.includes(estateId);
                });
                estatesAfterApplyingFilter = listAfterSecondFilter;
            }
            if (modifyDisplayStausSelectedIds.length > 0) {
                let listAfterThirdFilter = estatesAfterApplyingFilter.filter(item =>
                    modifyDisplayStausSelectedIds.includes(item.displayStatusId)
                );
                estatesAfterApplyingFilter = listAfterThirdFilter;
            }
            if (purposeStatusId != "") {
                let filteredEstatesList = estatesAfterApplyingFilter.filter(item => {
                    return item.purpose.id == purposeStatusId;
                })
                setFilteredEstates(filteredEstatesList);
                estatesAfterApplyingFilter = filteredEstatesList;
            }
            setClientEstates(listOfEstates);
            setFilteredEstates(estatesAfterApplyingFilter);
            getEstateStatusListFromDB(listOfEstates);
            dispatch(setAllEstatesList(listOfEstates)); // set all estate list in the redux
        }
    }

    const getWhiseEstatesListByPagin = async (clientToken, estateLimit, pageOffset) => {
        let url = "https://api.whise.eu/v1/estates/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };
        let response = await axios.post(url, {
            "Filter": {
                "StatusIds": [1],
                "PurposeStatusIds": [1, 2, 5, 6, 10, 11, 12, 13, 15, 16, 20, 21, 27, 28],
                "DisplayStatusIds": [1, 2, 3, 4, 5],
                "LanguageId": reduxSelectedLanguage ? reduxSelectedLanguage : null
            },
            "Page": {
                "Limit": estateLimit,
                "Offset": pageOffset
            },
            "Sort": [
                { "Field": "updateDateTime", "Ascending": false }
            ]
        }, config)

        return response.data;
    }

    const getEstateIdsHavingConfigSaved = async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Calendar/GetEstateIdsSavedInConfigurations?clientId=${user.user.clientId}`;

        await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let _esateIdsHavingConfigs = response.data;
                if (_esateIdsHavingConfigs != null) {
                    setEstateIdsHavingConfiguration(_esateIdsHavingConfigs);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });

    }

    const handlerCollapseProperties = () => {
        if (isPropertiesCollapsed == true) {
            setIsPropertiesCollapsed(false);
        }
        else {
            setIsPropertiesCollapsed(true);
        }
        setOpenDropdownId(null);
    }

    const handlerPropertyClick = (property) => {
        getContactWaitingList(property.id); // get waiting list data

        let currentProp = property;
        setSelectedProperty(current => currentProp);
        dispatch(setselectedproperty(currentProp));
        setOpenDropdownId(null);

        if (clientEstates.length > 0) {
            getEstateStatusListFromDB(clientEstates); // get all estate status
        }

        getEstatePurposeConfigJobStatusBtn(property.id);
    }

    const showCalendarFilters = (e) => {
        if (showHideCalendarFilter == true) {
            setShowHideCalendarFilter(false);
        }
        else {
            setShowHideCalendarFilter(true);
        }
    }

    const getAgents = async (clientToken) => {
        let url = "https://api.whise.eu/v1/admin/representatives/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                setWhiseAgents(response.data.representatives);
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const handlerAddSlot = () => {
        dispatch(cleareventdetail());
        setShowModal(true);
    }

    /////////////////////4/8/2024//////////////
    const getOfficeSettings = () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let settings = response.data;
                //console.log(settings);
                if (response.data != null) {
                    setOfficeSettings(response.data);
                    dispatch(setsetting(response.data));

                    let toBeConfirmed = [settings.visitToSaleBefore, settings.visitToRentBefore];
                    let cofirmed = [settings.visitToSaleAfter, settings.visitToRentAfter];
                    let freeslot = [settings.visitToSaleFreeSlot, settings.visitToRentFreeSlot];

                    setTobeConfirmedIds(toBeConfirmed);
                    setConfirmedIds(cofirmed);
                    setFreeSlotIds(freeslot);
                    //setWaitingListEnabled(settings.waitingListEnabled);

                    const contactTitlesListJsonParse = settings.mappedContactTitles != "" ? JSON.parse(settings.mappedContactTitles) : [];
                    setContactTitlesList(contactTitlesListJsonParse);

                    if (settings.officesDetail == "" || settings.officesDetail == null) {
                        getWhiseOffices();
                    } else {
                        let _officesDetail = JSON.parse(settings.officesDetail);
                        if (_officesDetail.length > 0) {
                            //console.log(_officesDetail);
                            setOfficeList(_officesDetail);
                            setSelectOffice(_officesDetail[0].Id);
                            let _filteredOffice = _officesDetail.filter((item) => { return item.Id == officeId });
                            setWhiseOffice(_filteredOffice[0]);
                            //setIsOfficesLoaded(true);
                        }
                        else {
                            getWhiseOffices();
                        }
                    }
                }
                else {
                    //window.location.href = "/settings";
                    navigate("/settings");
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    useEffect(() => {
        if (whiseUserToken) {
            getOfficeSettings();
        }
    }, [whiseUserToken]);

    const getAction = (actionId) => {
        let action = calendarActions.filter((d) => d.id === +actionId);
        return action[0].name;
    }

    function toLocalISOString(date) {
        const offsetInMinutes = date.getTimezoneOffset();
        const adjustedDate = new Date(date.getTime() - offsetInMinutes * 60 * 1000);
        return adjustedDate.toISOString().slice(0, 19); // Remove milliseconds and 'Z'
    }

    const getWhiseCalenderEvents = async (callingFrom, _startDate, _endDate, view, activeEstateList) => {
        let currentView = view || (reduxCalendarView ? reduxCalendarView.view : "timeGridWeek");
        let startDate, endDate;

        // Convert _startDate and _endDate to Date objects if they are strings
        if (_startDate) _startDate = new Date(_startDate);
        if (_endDate) _endDate = new Date(_endDate);

        // Determine the date range
        if (!_startDate || !_endDate) {
            ({ startDate, endDate } = getDateRangeForView(currentView));
        } else {
            startDate = toLocalISOString(_startDate);
            endDate = toLocalISOString(_endDate);
        }

        setCurrentRange({ start: startDate, end: endDate });
        dispatch(setCalendarView({ startDate, endDate, view: currentView }));

        let savedCalendarActions = [...new Set([...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds])];

        let estateEvents = selectedProperty ?
            await getWhiseCalendarEventsForSelectedEstate(startDate, endDate, selectedProperty.id, savedCalendarActions, activeEstateList) : [];

        let agentEvents = selectedAgents.length > 0 ?
            await getWhiseCalendarEventsForSelectedAgent(startDate, endDate, selectedAgents[0].agentDetail.id, selectedProperty.id, activeEstateList) : [];

        // Remove duplicate events object same array
        const removeDuplicateObjFromData = data => [
            ...new Map(
                data.map(item => [
                    item.id ?? item.whiseEventId,
                    item.whiseEventId ? item : (data.find(d => d.whiseEventId === item.id) || item)
                ])
            ).values()
        ];

        const uniqueEstateEvents = removeDuplicateObjFromData(estateEvents);
        const uniqueAgentEvents = removeDuplicateObjFromData(agentEvents);

        // old 
        /* let uniqueEvents = [
             // always include agents
             ...estateEvents,
             ...agentEvents.filter(
                 e => !estateEvents.some(a => a.whiseEventId === e.id || a.id === e.id) // include only estate events that don't match an agent
             )
         ];*/

        const uniqueEvents = [
            ...uniqueEstateEvents,
            ...uniqueAgentEvents.filter(e => !uniqueEstateEvents.some(a => a.whiseEventId === e.id || a.id === e.id))
        ];

        // console.log(uniqueEvents);
        dispatch(setFetchLatestRecordStatus(false)); // render latest record

        setWhiseCalendarEvents(uniqueEvents);
        if (user && user.user.firstSynchronization) {
            setShowCalendarLoader(false);
        }
    };

    // Helper function to get the date range based on the current view
    const getDateRangeForView = (view) => {
        let date = new Date();
        let startDate, endDate;

        if (view === "timeGridDay") {
            // Set to current day 12:00 AM to 11:59:59 PM
            date.setHours(0, 0, 0, 0);
            startDate = date;
            date.setHours(23, 59, 59, 999);
            endDate = date;
        } else if (view === "dayGridMonth") {
            // Set to first and last date showing in the month view grid
            let firstDayShowing = new Date(date.getFullYear(), date.getMonth(), 1);
            firstDayShowing.setDate(firstDayShowing.getDate() - firstDayShowing.getDay()); // Adjust to Sunday of the first week shown
            firstDayShowing.setHours(0, 0, 0, 0);

            let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            let lastDayShowing = new Date(lastDayOfMonth);
            lastDayShowing.setDate(lastDayOfMonth.getDate() + (6 - lastDayOfMonth.getDay()));
            lastDayShowing.setHours(23, 59, 59, 999);

            startDate = firstDayShowing;
            endDate = lastDayShowing;
        } else {
            // Default to week view
            let firstDayOfWeek = new Date(date);
            firstDayOfWeek.setDate(date.getDate() - ((date.getDay() + 6) % 7));
            firstDayOfWeek.setHours(0, 0, 0, 0);

            let lastDayOfWeek = new Date(firstDayOfWeek);
            lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
            lastDayOfWeek.setHours(23, 59, 59, 999);

            startDate = firstDayOfWeek;
            endDate = lastDayOfWeek;
        }

        return { startDate: toLocalISOString(startDate), endDate: toLocalISOString(endDate) };
    };

    //Fetch events for selected estate from whise and DB
    const getWhiseCalendarEventsForSelectedEstate = async (startDate, endDate, estateId, calendarActions, allActiveEstateList, callFutureAndPastEvent) => {
        var eventLimit = 300;
        var pageOffset = 0;
        let listOfEvents = [];

        let activeEstateList = allActiveEstateList == undefined ? reduxActiveEstateList : allActiveEstateList;
        const isActiveEstate = activeEstateList.includes(estateId); // check estate active from local db

        const callToWhiseFutureAndPastEvents = callFutureAndPastEvent == undefined ? "localdb" : callFutureAndPastEvent;

        // get free slots from Database on active estate
        if (isActiveEstate && callToWhiseFutureAndPastEvents == "localdb") {
            let responseLocalDBEvents = await getCalendarEventsFromDB(startDate, endDate, "estate", estateId, calendarActions);
            if (responseLocalDBEvents.totalCount != undefined && responseLocalDBEvents.totalCount > 0) {
                listOfEvents.push(...responseLocalDBEvents.calendars);
            }
            //console.log(listOfEvents);
            return listOfEvents;
        }

        // Estate is deactivated → fetch all active estates events
        /*  for (let activeEstateId of activatedEstates) {
              const events = await getCalendarEventsFromDB(startDate, endDate, "estate", activeEstateId, calendarActions);
              if (events.totalCount > 0) listOfEvents.push(...events.calendars);
          }*/

        let _response = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "estate", estateId, calendarActions);

        //get free slots saved in Database only when Synchronization on Whise is disabled
        if (officeSettings.syncEventsToWhise == false) {
            let responseLocalDBEvents = await getCalendarEventsFromDB(startDate, endDate, "estate", estateId, calendarActions);
            if (responseLocalDBEvents.totalCount != undefined && responseLocalDBEvents.totalCount > 0) {
                listOfEvents.push(...responseLocalDBEvents.calendars);
            }
        }

        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEvents.push(..._response.calendars);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = eventLimit * i + 1;
                let _eventResponse = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "estate", estateId, calendarActions);
                if (_eventResponse.calendars != undefined && _eventResponse.calendars.length > 0) {
                    listOfEvents.push(..._eventResponse.calendars);
                }
            }
        }
        else if (_response.calendars != undefined && _response.calendars.length > 0) {
            listOfEvents.push(..._response.calendars);
        }

        return listOfEvents;
    }

    //Fetch events for selected agent from whise and DB
    const getWhiseCalendarEventsForSelectedAgent = async (startDate, endDate, agentId, estateId, allActiveEstateList) => {
        var eventLimit = 300;
        var pageOffset = 0;
        let listOfEvents = [];

        let _response = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "agent", agentId);

        //get free slots saved in Database only when Synchronization on Whise is disabled
        if (officeSettings.syncEventsToWhise == false) {
            let responseLocalDBEvents = await getCalendarEventsFromDB(startDate, endDate, "agent", agentId);
            if (responseLocalDBEvents.totalCount != undefined && responseLocalDBEvents.totalCount > 0) {
                listOfEvents.push(...responseLocalDBEvents.calendars);
            }
        }

        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEvents.push(..._response.calendars);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = eventLimit * i + 1;
                let _eventResponse = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, "agent", agentId);
                if (_eventResponse.calendars != undefined && _eventResponse.calendars.length > 0) {
                    listOfEvents.push(..._eventResponse.calendars);
                }
            }
        }
        else if (_response.calendars != undefined && _response.calendars.length > 0) {
            listOfEvents.push(..._response.calendars);
        }

        return listOfEvents;
    }

    //Get events from whise with pagination
    //This method will hit twice if in first call event count is greater than 300
    const getWhiseCalendarEventsByPagination = async (eventLimit, pageOffset, startDate, endDate, callingFor, entityId, calendarActions) => {

        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            "Filter": {
                "DateTimeRange": {
                    "Min": startDate,
                    "Max": endDate
                },
                "IncludeRecurrences": true
            },
            "Page": {
                "Limit": eventLimit,
                "Offset": pageOffset
            }
        };

        // Conditionally add estate and agentId
        if (callingFor == "estate") {
            body["Filter"]["EstateIds"] = [entityId];
            body["Filter"]["CalendarActionIds"] = calendarActions;
        }
        else {
            body["Filter"]["UserIds"] = [entityId];
        }

        let response = await axios.post(url, body, config);

        return response.data;
    }

    //Get events saved in local database
    const getCalendarEventsFromDB = async (startDate, endDate, callingFor, entityId, calendarActions) => {
        // Generate query string
        let payload = {
            clientId: clientId,
            officeId: officeId,
            startDate: startDate,
            endDate: endDate
        };

        // Conditionally add estateId and agentId
        if (callingFor == "estate") {
            payload.estateId = entityId;
            payload.calendarActions = `${calendarActions}`;
        }
        else {
            payload.agentId = entityId;
        }

        let url = variables.API_URL + `LocalEvents/GetLocalEvent?`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, JSON.stringify(payload), config);

        return response.data;
    }

    const deleteCalendarEventsFromDB = async (clientId, estateId) => {
        if (reduxProperty.id) {
            let url = variables.API_URL + `LocalEvents/DeleteEventsByEstateId?clientId=${clientId}&estateId=${reduxProperty.id}`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            let response = await axios.post(url, {}, config);

            return response.data;
        }
    }

    const addWhiseCalenderEvent = async (body, traceExpection, freeSlotInternalIds, whiseEventIds) => {

        try {
            let url = "";
            let config = null;

            if (userAccountType == variables.UserAccountTypeIdentity) { // "SystemIntegrator"
                url = "https://api.whise.eu/v1/calendars/create";

                config = {
                    headers: {
                        'Authorization': `Bearer ${clientTokenByAccountType}`,
                        'Content-Type': 'application/json'
                    },
                };
            } else {
                url = "https://api.whise.eu/v1/calendars/upsert";

                config = {
                    headers: {
                        'Authorization': `Bearer ${clientToken}`,
                        'Content-Type': 'application/json'
                    },
                };
            }

            const response = await axios.post(url, body, config);

            // error email send if calendar/create api failed
            if (response.data.calendarId == undefined && response.data.isValidRequest == false) {

                // error email send if calendar/create api failed
                if (userAccountType == variables.UserAccountTypeIdentity) {
                    const eventDetail = {
                        clientId: clientId,
                        reason: JSON.stringify(response.data),
                        eventDetail: body
                    }
                    sendCalendarCreateApiErrorEmail("en-GB", eventDetail);
                }

                showMessage("error", "Internal server error");
                traceExpection.push("https://api.whise.eu/v1/calendars/upsert");
                throw new Error(JSON.stringify(response.data)); // throw error to parent fun
            }

            whiseEventIds.push(response.data.calendarId); // push whise event id

            await dumpNewlyCreatedWhiseEventInDB(response.data.calendarId, traceExpection, freeSlotInternalIds);

            if (response.data.calendarId !== undefined && reduxEventDetail.invitee) {
                const configuration = {
                    Name: reduxEventDetail.invitee.Name,
                    FirstName: reduxEventDetail.invitee.FirstName,
                    Email: reduxEventDetail.invitee.Email,
                    Mobile: reduxEventDetail.invitee.Mobile,
                    Questions: reduxEventDetail.invitee.Question,
                    Documents: reduxEventDetail.invitee.Documents,
                    AgentRecap: reduxEventDetail.invitee.AgentOnSiteRecap,
                    EventId: response.data.calendarId,
                    ContactId: +contactId,
                };
                saveEventConfigurations(configuration);
            }
        } catch (error) {
            showMessage("error", error.message);
            traceExpection.push("https://api.whise.eu/v1/calendars/upsert");

            throw new Error(error.message);
        }
    };

    // get future 3 month events
    const getFutureThreeMonthWhiseEvents = async (estateId, activeEstateList) => {
        //console.log(estateId);
        const now = new Date();
        const startDate = now.toISOString();

        const maxDate = new Date(now);
        maxDate.setMonth(maxDate.getMonth() + 3);
        const endDate = maxDate.toISOString();

        let calendarActions = [freeSlotIds[0], tobeConfirmedIds[0], confirmedIds[0]];

        const getFutureThreeMonthEvents = await getWhiseCalendarEventsForSelectedEstate(startDate, endDate, estateId, calendarActions, activeEstateList, "futureAndPastEvents");
        //eventObj.EstateIds[0]
        //const allFutureEventsList = getFutureThreeMonthEvents.map(item => ({ ...item, clientId: clientId }));

        const allFutureEventsList = getFutureThreeMonthEvents.map(
            ({ patternEndDate, ...rest }) => ({
                ...rest,
                ...(patternEndDate == null || patternEndDate === ""
                    ? {}
                    : { pattern: patternEndDate }),
                clientId,
                estates: [{ ...reduxProperty, estateId: reduxProperty.id }]
            })
        );

        await pushAllHistoryEventInLocalDB(allFutureEventsList); // push all event in local db
    }

    // get past 1 year confirmed events
    const getPastOneYearConfirmedWhiseEvents = async (estateId, activeEstateList) => {

        const now = new Date();
        const endDate = now.toISOString();

        const maxDate = new Date(now);
        maxDate.setFullYear(now.getFullYear() - 1); // add past 1 year
        const startDate = maxDate.toISOString().split('.')[0];

        let calendarActions = [confirmedIds[0]];
        //eventObj.EstateIds[0],
        const getPastOneYearEvents = await getWhiseCalendarEventsForSelectedEstate(startDate, endDate, estateId, calendarActions, activeEstateList, "futureAndPastEvents");

        //const allPastOneYearConfirmEventsList = getPastOneYearEvents.map(item => ({ ...item, clientId: clientId }));

        // new : all estate save in every estate array/object
        const allPastOneYearConfirmEventsList = getPastOneYearEvents.map(item => ({
            ...item,
            clientId: clientId,
            estates: [{ ...reduxProperty, estateId: reduxProperty.id }]
        }));

        await pushAllHistoryEventInLocalDB(allPastOneYearConfirmEventsList); // push all event in local db

    };

    // new event object dump in db
    const dumpNewlyCreatedWhiseEventInDB = async (eventId, traceExpection, freeSlotInternalIds) => {

        let url = "https://api.whise.eu/v1/calendars/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        const body = {
            Filter: {
                CalendarIds: [eventId]
            }
        }

        await axios.post(url, body, config)
            .then(async (response) => {
                if (response.data.totalCount != undefined && response.data.totalCount > 0) {
                    let event = response.data.calendars;
                    //console.log(event);
                    if (event[0].estates.length > 0) {
                        const event = response.data.calendars;
                        if (event[0].estates.length > 0) {
                            event[0].estates[0] = {
                                ...reduxProperty,
                                estateId: reduxProperty.id
                            }
                        }
                        event[0].clientId = clientId;

                        await pushEventInDB(event[0], traceExpection, freeSlotInternalIds);
                    } else {
                        traceExpection.push("https://api.whise.eu/v1/calendars/list");
                        throw new Error(JSON.stringify(response.data));
                    }
                } else {
                    traceExpection.push("https://api.whise.eu/v1/calendars/list");
                    throw new Error(JSON.stringify(response.data));
                }
            })
            .catch(error => {
                showMessage("error", error.message);
                traceExpection.push("https://api.whise.eu/v1/calendars/list");

                throw new Error(JSON.stringify(error.message));
            });
    }

    // push all events in local db
    const pushEventInDB = async (allEvents, traceExpection, freeSlotInternalIds) => {
        let url = variables.API_URL + `calendar/SyncWhiseEventCreationInDB?`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };
        //console.log(allEvents);
        await axios.post(url, allEvents, config)
            .then(response => {
                if (response.data) {
                    // add free slot internal ids for log save in db
                    freeSlotInternalIds.push(response.data.internalEventId);
                } else {
                    traceExpection.push("calendar/SyncWhiseEventCreationInDB?");
                    throw new Error(JSON.stringify(response.data));
                }
            })
            .catch(error => {
                console.log("error", error);
                traceExpection.push("calendar/SyncWhiseEventCreationInDB?");
                throw new Error(JSON.stringify(error.message));
            });
    }

    // push all history events in local db
    const pushAllHistoryEventInLocalDB = async (allEvents) => {

        try {
            let url = variables.API_URL + `calendar/SyncBulkEventsFromWhiseInDB?`;

            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };
            console.log(allEvents);
            const response = await axios.post(url, allEvents, config);

            if (response.data) {
                console.log(response.data);
            }

        } catch (error) {
            console.log("Error SyncBulkEvents api:", error);
        }

        //console.log(allEvents);
        //await axios.post(url, allEvents, config)
        //    .then(response => {
        //        if (response.data) {
        //            console.log(response.data);
        //        }
        //    })
        //    .catch(error => {
        //        console.log("error", error);
        //    });
    }

    // close show model after create new free slot event
    const closeShowModal = () => {
        setShowModal(false);
        setTimeout(() => {
            setPreviewEvent(false);
            setIsEstateConfigurationsEdit(false);
            dispatch(setShowEditEstateConfigModal(false)); // edit estate config modal
        }, 200)
    }

    // all event detail remove in redux
    const removeEventDetailInReduxAfterCreateNewFreeSlotEvents = () => {
        dispatch(cleareventdetail());
        dispatch(clearBookAbleUntil());
        dispatch(clearDuplicateTimeSlots());
        dispatch(clearScheduleTimeSlotDetail());
    }

    const deleteWhiseCalendarEvent = async (event, eventConfigration) => {
        // console.log(event);
        let checkContactStatus = null;
        if (eventConfigration != undefined) {
            const contactStatusApiObj = {
                contactId: eventConfigration.ContactIds[0],
                estateId: eventConfigration.EstateIds[0]
            }

            checkContactStatus = await checkContactStatusFromWhise(clientToken, contactStatusApiObj); // check contact current status from whise
        }

        if (event) {
            if (eventConfigration == undefined) {
                setShowCalendarLoader(true);
            }
            let url = "https://api.whise.eu/v1/calendars/delete";
            let headers = {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            };
            let body = {
                "CalendarIds": [event.whiseEventId || event.eventId]
            };
            axios.delete(url, { data: body, headers: headers })
                .then(response => {
                    if (response.data) {
                        if (eventConfigration != undefined) {
                            addConfirmedWhiseCalenderEvent(event, eventConfigration, checkContactStatus);
                        }
                        else {
                            deletCalendarEventFromLocalDB(event);
                            let calendarViewDetails = reduxCalendarView;
                            getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
                        }
                    }
                })
                .catch(error => {
                    console.log("error", error);
                });
        }
    }

    const deletCalendarEventFromLocalDB = async (event) => {

        let url = variables.API_URL + `LocalEvents/DeleteEventsById?eventId=${+event.eventId}`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                if (response.data) {
                    updateEstateStatusInDB(event.estates[0].estateId);
                    setShowCalendarLoader(true);
                    let calendarViewDetails = reduxCalendarView;
                    getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
                }
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    const handleConfirmWindowClose = () => {
        setShowConfirmWindow(false);
        setIsDeleteConfirmed(false);
        setFreeSlotsEstateIdToBeDeleted(null);
        setClickedDeleteFreeSlotButton(null);
    }

    const callBackConfirmDeleteFreeSlots = (flag) => {
        if (flag == true) {
            setIsDeleteConfirmed(flag);
            setShowConfirmWindow(false);
        }
        else {
            setIsDeleteConfirmed(false);
            setShowConfirmWindow(false);
            setFreeSlotsEstateIdToBeDeleted(null);
            setClickedDeleteFreeSlotButton(null);
        }
    }

    useEffect(() => {
        if (isDeleteConfirmed == true && clickedDeleteFreeSlotButton && freeSlotsEstateIdToBeDeleted) {

            const handleDelete = async () => {  // inner async function

                let e = clickedDeleteFreeSlotButton;
                let estateId = freeSlotsEstateIdToBeDeleted;

                // Now await works fine
                const previousEstateStatus = await getEstateStatusFromInDB(estateId, clientId);

                setShowCalendarLoader(true);
                e.target.setAttribute("disabled", true);
                e.target.style.cursor = "progress";
                document.querySelector("body").style.cursor = "progress";

                let url = variables.API_URL + `calendar/DeleteEstateFreeSlots?clientId=${clientId}&estateId=${estateId}`;
                const config = {
                    headers: {
                        'Authorization': `Bearer ${user.tokenValue}`,
                        'Content-Type': 'application/json'
                    },
                };

                axios.post(url, {}, config)
                    .then(async response => {
                        if (response.status == 200) {

                            let _delDbFreeSlotResponse;
                            try {
                                _delDbFreeSlotResponse = await deleteCalendarEventsFromDB(clientId, estateId);
                            } catch (dbError) {
                                console.error('Error deleting calendar events from DB:', dbError);
                                const newEstateStatus = await getEstateStatusFromInDB(estateId, clientId);
                                const actionLogObj = {
                                    estateId: +estateId,
                                    clientId: +clientId,
                                    actionId: 4,
                                    actionStatus: false,
                                    metadata: JSON.stringify({
                                        oldEstateStatus: previousEstateStatus,
                                        newEstateStatus: newEstateStatus,
                                        description: `Free slot DB delete failed`
                                    }),
                                    performedBy: "agent",
                                    parentLogId: null,
                                    syncWithWhise: false,
                                    origin: "EU",
                                    exception: `${JSON.stringify(dbError)}`
                                };
                                addNewActionsLog(actionLogObj);
                                updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });
                                return;
                            }

                            //console.log(_delDbFreeSlotResponse);

                            let calendarViewDetails = reduxCalendarView;
                            getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
                            e.target.removeAttribute("disabled");
                            e.target.style.cursor = "";
                            document.querySelector("body").style.cursor = "";
                            setFreeSlotsEstateIdToBeDeleted(null);
                            setClickedDeleteFreeSlotButton(null);
                            setIsDeleteConfirmed(false);
                            updateEstateStatusInDB(estateId);

                            const newEstateStatus = await getEstateStatusFromInDB(estateId, clientId);
                            const freeSlotDeleteCount = getStartingNumber(_delDbFreeSlotResponse);

                            // action log
                            let actionLogObj = {
                                estateId: +estateId,
                                clientId: +clientId,
                                actionId: 4,
                                actionStatus: true,
                                metadata: JSON.stringify({
                                    oldEstateStatus: previousEstateStatus,
                                    newEstateStatus: newEstateStatus,
                                    freeslotDeleteCount: freeSlotDeleteCount,
                                    description: `${freeSlotDeleteCount} free slot is deleted`
                                }),
                                performedBy: "agent",
                                parentLogId: null,
                                syncWithWhise: false,
                                origin: "EU",
                                exception: null
                            };

                            addNewActionsLog(actionLogObj); // action log
                        }
                    })
                    .catch(async (error) => {
                        console.error('Error deleting free slots:', error);
                        setShowCalendarLoader(false);
                        e.target.removeAttribute("disabled");
                        e.target.style.cursor = "";
                        document.querySelector("body").style.cursor = "";
                        setFreeSlotsEstateIdToBeDeleted(null);
                        setClickedDeleteFreeSlotButton(null);
                        setIsDeleteConfirmed(false);

                        const newEstateStatus = await getEstateStatusFromInDB(estateId, clientId);

                        // action log
                        let actionLogObj = {
                            estateId: +estateId,
                            clientId: +clientId,
                            actionId: 4,
                            actionStatus: false,
                            metaData: JSON.stringify({
                                oldEstateStatus: previousEstateStatus,
                                newEstateStatus: newEstateStatus,
                                description: `Free slot is not deleted`
                            }),
                            performedBy: "agent",
                            parentLogId: null,
                            syncWithWhise: false,
                            origin: "EU",
                            exception: `${JSON.stringify(error)}`
                        };

                        addNewActionsLog(actionLogObj);
                        updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metaData, exception: actionLogObj.exception });

                    });
            };

            handleDelete();
        }
    }, [isDeleteConfirmed, clickedDeleteFreeSlotButton, freeSlotsEstateIdToBeDeleted]);

    const handleDeleteAllFreeSlotsClick = async (e, estateId) => {
        setConfirmWindowMessage(reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalYouWantDeleteEventPastFreeSlots"] : "Do you want to delete past free slots?");
        setShowConfirmWindow(true);
        setFreeSlotsEstateIdToBeDeleted(estateId);
        setClickedDeleteFreeSlotButton(e);
    }

    const updateEstateStatusInDB = async (estateId) => {
        try {
            let url = `${variables.API_URL}LocalEvents/UpdateEstateStatus`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const body = {
                estateId: estateId,
                clientId: +clientId
            }

            const response = await axios.post(url, body, config);

            if (response && clientEstates.length > 0) {
                // latest get all estate status
                getEstateStatusListFromDB(clientEstates);
            }
        } catch (error) {
            console.log("event update in db:", error);
        }
    }

    const acceptToBeConfirmedEvents = async (event) => {
        //setEventToBeAccepted(event);
        //getEstateById(event.estates[0].estateId);

        try {
            setShowModal(false);
            setShowCalendarLoader(true);

            let eventObj = event.whiseEventIdStatus == null ? { eventId: +event.eventId } : { whiseEventId: +event.whiseEventId }

            // get latest estate id from db => if current estate rent/sold
            let getLatestEstateId = await getLatestEstateIdFromDB(event.estates[0].estateId);

            let body = {
                "clientId": +clientId,
                "estateId": +getLatestEstateId, //event.estates[0].officeId,
                "contactId": event.contacts[0].contactId,
                // "eventId": event.eventId,
                "officeId": event.estates[0].officeId || +selectOffice, //+officeId,
                "agentId": event.users[0].userId,
                ...eventObj,
            }

            //console.log(body);

            await convertTBCToConfirmedEvent(body);

            let calendarViewDetails = reduxCalendarView;
            getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
        } catch (error) {
            console.log("accpetTobeConfrimedEventError", error);
        }
    }

    const getEstateById = (estateId) => {
        let url = "https://api.whise.eu/v1/estates/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post('/user', document.querySelector('#my-form'), {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        axios.post(url, {
            "Filter": {
                "EstateIds": [estateId],
            }
        }, config)
            .then(response => {
                if (response.data.estates != undefined) {
                    setEstateDetailForEventToBeAccepted(response.data.estates);
                }
            })
            .catch(error => {
                console.log("error", error)
            });
    }

    const addConfirmedWhiseCalenderEvent = async (eventDetail, body, contactStatus) => {
        try {

            let newContactId = null;
            let contactObj = [];
            let oldContactId = body.ContactIds[0];
            let contactAlreadyExistInDB = false;
            let contactMultiTimeDelete = false;

            const getDummpyEventObj = await createDummpyEventObj(body); // get dumpy event obj

            const createDumpyEvent = await addWhiseCalendarEventService(clientToken, getDummpyEventObj); // add dummpy event on whise

            //const contactDetailFromDB = await getContactDetailFromDB(body.ContactIds[0]); // get contact detail from local db

            const contactDetailFromDB = await getContactDetailFromDB(oldContactId); // get contact detail from local db

            if (contactDetailFromDB.id != oldContactId) { // body.ContactIds[0]

                const newContactIdInner = contactDetailFromDB.id;
                newContactId = contactDetailFromDB.id;

                const convertTitleObj = JSON.parse(contactDetailFromDB.contactTitle);

                const newContactObj = {
                    contactId: newContactIdInner,
                    name: contactDetailFromDB.name,
                    firstName: contactDetailFromDB.firstName,
                    contactTitle: { id: convertTitleObj.Id || convertTitleObj.id },
                    country: { id: 1 },
                    languageId: contactDetailFromDB.languageId || 'fr-BE',
                    privateMobile: contactDetailFromDB.privateMobile,
                    privateEmail: contactDetailFromDB.privateEmail,
                    agreementEmail: true,
                    agreementSms: true,
                    funnelStatusId: 3,
                    attendeeStatus: { id: 1 }
                }

                contactObj.push(newContactObj);

                // again dumpy event create if contact id is not match with db and url contact id
                const getDummpyEventObj = await createDummpyEventObj(body, newContactIdInner); // get dumpy event obj
                const dummpyEvent = await addWhiseCalendarEventService(clientToken, getDummpyEventObj); // add dummpy event on whise

                /// status check when contact ids different in db and TBC event
                const contactStatusObj = {
                    contactId: newContactIdInner,
                    estateId: body.EstateIds[0]
                }

                contactStatus = await checkContactStatusFromWhise(clientToken, contactStatusObj); // check contact current status from whise

                deletWhiseEventService(clientToken, dummpyEvent); // delete dumpy event from whise
            }

            if ((contactStatus == 3 && contactStatus != null) || contactStatus === true) { // contactStatus = 3 mean => delet contact from whise
                /*const contactDetailFromDB = await getContactDetailFromDB(body.ContactIds[0]); // get contact detail from local db*/
                contactAlreadyExistInDB = true;

                if (contactStatus == true) {
                    contactMultiTimeDelete = true;
                    contactObj = [];
                }

                if (contactDetailFromDB) {
                    let contactbody = {
                        Name: contactDetailFromDB.name,
                        PrivateEmail: contactDetailFromDB.privateEmail,
                        OfficeIds: [eventDetail.estates[0].officeId],
                        PrivateMobile: contactDetailFromDB.privateMobile,
                        FirstName: contactDetailFromDB.firstName,
                        CountryId: 1,
                        StatusId: 1,
                        EstateIds: [body.EstateIds[0]],
                        Message: "Contact created via Smartcalendar app",
                        AgreementEmail: true,
                        AgreementSms: true,
                        AgreementMailingCampaign: true,
                        AgreementSmsCampaign: true,
                        LanguageId: contactDetailFromDB.languageId || 'fr-BE',  //'fr-BE'
                    };

                    const getNewContactId = await addNewContactOnWhise(clientToken, contactbody); // add new contact on whise, get detail from local db

                    newContactId = getNewContactId;

                    const convertTitleObj = JSON.parse(contactDetailFromDB.contactTitle);

                    const newContactObj = {
                        contactId: getNewContactId,
                        name: contactDetailFromDB.name,
                        firstName: contactDetailFromDB.firstName,
                        contactTitle: { id: convertTitleObj.Id || convertTitleObj.id },
                        country: { id: 1 },
                        languageId: contactDetailFromDB.languageId || 'fr-BE',
                        privateMobile: contactDetailFromDB.privateMobile,
                        privateEmail: contactDetailFromDB.privateEmail,
                        agreementEmail: true,
                        agreementSms: true,
                        funnelStatusId: 3,
                        attendeeStatus: { id: 1 }
                    }

                    contactObj.push(newContactObj);
                }
            }

            const eventObj = {
                calendarActionId: body.CalendarActionId,
                estateId: body.EstateIds[0],
                agentId: body.UserIds[0],
                startDateTime: body.StartDateTime,
                endDateTime: body.EndDateTime,
            }

            deletWhiseEventService(clientToken, createDumpyEvent); // delete dumpy event from whise
            const isEventAlreadyExitInDb = await isEventTimeAvailableInDB(eventObj); // check event is already exist with same time in db

            body.StartDateTime = isEventAlreadyExitInDb.startDateTime;
            body.EndDateTime = isEventAlreadyExitInDb.endDateTime;
            body.subject = `${body.subject} ${contactDetailFromDB.firstName} ${contactDetailFromDB.name}`;
            //body.UserIds[0] = newContactId = ! null ? body.ContactIds[0] : newContactId; // set new contact id
            body.ContactIds[0] = newContactId != null ? newContactId : body.ContactIds[0]; // set new contact id

            const newEventWhiseId = await addWhiseCalendarEventService(clientToken, body); // add confirmed event on whise with latest object

            if (newEventWhiseId) {

                const newEventDetailObj = {
                    id: null,
                    oldWhiseEventId: eventDetail.whiseEventId,
                    newWhiseEventId: newEventWhiseId,
                    calendarActionId: body.CalendarActionId,
                    subject: body.subject,
                    actionType: "confirmed",
                    eventStartDateTime: body.StartDateTime,
                    eventEndDateTime: body.EndDateTime,
                    contacts: contactObj.length > 0 ? contactObj : null,  //null,
                    oldContactId: contactMultiTimeDelete == true ? `${contactDetailFromDB.id}` : `${oldContactId}`,
                    newContactId: newContactId != null && contactAlreadyExistInDB ? `${newContactId}` : null,
                    clientId: +clientId
                }

                updateEventDetailInDB(newEventDetailObj); // update local db with new data
                sendSecondEmail(eventDetail, body, contactDetailFromDB);
                //setShowCalendarLoader(false); // remove this because it create the jurk
            }
        } catch (error) {
            console.log(error);
        }

        //const response = await axios.post(url, body, config);
        /*let url = "https://api.whise.eu/v1/calendars/upsert";
            const config = {
                headers: {
                    'Authorization': `Bearer ${clientToken}`,
                    'Content-Type': 'application/json'
                },
            };*/
        /*  axios.post(url, body, config)
              .then(response => {
                  sendSecondEmail();
                  setShowCalendarLoader(false);
              })
              .catch(error => {
                  console.log("error", error)
              });*/
    }

    const sendSecondEmail = async (previousEventDetail, eventBody, contactDetail) => {
        try {

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            let estate = estateDetailForEventToBeAccepted[0];

            const officeLogoUrl = await getOfficeLogoService(estate.officeId); // get office logo from database
            const whiseClientSetting = await getClientSettingService(whiseUserToken, estate.clientId); // get client whise setting

            const titleList = await getContactTitleListService(clientToken); // get client titles list from whise

            const convertTitleObj = JSON.parse(contactDetail.contactTitle);
            const titleId = convertTitleObj.Id || convertTitleObj.id;

            const contactTitle = titleList.filter(item => item.id == titleId);

            let visitingDate = new Date(eventBody.StartDateTime);
            let hours = visitingDate.getHours() < 10 ? "0" + visitingDate.getHours() : visitingDate.getHours();
            let minutes = visitingDate.getMinutes() < 10 ? "0" + visitingDate.getMinutes() : visitingDate.getMinutes();
            let time = hours + ":" + minutes;

            /*let subject = `${selectedContactLanguageTranslations != null ? selectedContactLanguageTranslations["confirmationEmailSubjectStaticText1"] : "Confirmation: "} ${title[0].shortDescription + " " + whiseCalendarEvents[0].contacts[0].firstName} ${selectedContactLanguageTranslations != null ? selectedContactLanguageTranslations["confirmationEmailSubjectStaticText2"] : ", you're visiting the property "} ${estate.officeId} ${selectedContactLanguageTranslations != null ? selectedContactLanguageTranslations["confirmationEmailSubjectStaticText3"] : " on "} ${visitingDate.toDateString()} ${time}`;*/

            let subject = `${reduxLanguageTranslations ? reduxLanguageTranslations["confirmationEmailSubjectStaticText1"] : "Confirmation: "} ${contactTitle[0].shortDescription}  ${contactDetail.firstName} ${reduxLanguageTranslations ? reduxLanguageTranslations["confirmationEmailSubjectStaticText2"] : ", you're visiting the property "} ${estate.id} ${reduxLanguageTranslations ? reduxLanguageTranslations["confirmationEmailSubjectStaticText3"] : " on "} ${visitingDate.toDateString()} ${time}`;

            let html = "<div style='border: 1px solid gray; background-color: white; border-radius: 16px; padding: 20px; width: 80%; margin: 0 auto; text-align: left'>";
            //html += "   <div><img src='https://mink-smartcalendar-agent-ui.net7.be/static/media/sidebar-logo.c2f1f3f5618f7e01cbfd4410196de7f5.svg' style='margin-bottom: 1.5rem' /></div>";
            html += "   <div style='text-align: center'>";
            if (officeLogoUrl) {
                html += "   <img src='" + officeLogoUrl + "' width='200' style='margin: 0 auto; margin-bottom: 1.5rem;' />";
            }
            else if (whiseClientSetting != null && whiseClientSetting.logoUrl != undefined) {
                html += "   <img src='" + whiseClientSetting.logoUrl + "' width='200' style='margin: 0 auto; margin-bottom: 1.5rem;' />";
            } else {
                html += "   <img src='" + window.location.origin + "/assets/logo-placeholder.png' width='200' style='margin: 0 auto; margin-bottom: 1.5rem;' />";
            }
            html += "   <h5 style='font-size: 24px;font-weight: 500;color: #111827;font-family: Poppins; margin: 0; margin-bottom: 1.5rem'>Your Visit request has been accepted by <strong>" + eventToBeAccepted.users[0].name + "</strong> of the agency " + eventToBeAccepted.users[0].officeId + "</h5>";
            html += "   <div  style='margin-bottom: 1.5rem; border: 1px solid gray; border-radius: 8px; text-align: left; padding: 15px;'>";
            html += `       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem'>${reduxLanguageTranslations != null ? reduxLanguageTranslations["confirmationEmailVisitingPropertyLocatedText"] : "You're visiting the property located:"}</h5>`;
            html += "       <p style='font-family: Poppins; font-size: 14px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem'>" + (estate.address == undefined ? "" : estate.address) + " " + (estate.number == undefined ? "" : estate.number) + ", " + (estate.zip == undefined ? "" : estate.zip) + " " + (estate.city == undefined ? "" : estate.city) + "</p>";
            html += `       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem; margin-top: 1.5rem'>${reduxLanguageTranslations != null ? reduxLanguageTranslations["eventDenialEmailDateLabel"] : "Date"}</h5>`;
            /*html += "       <p style='font-family: Poppins; font-size: 14px; line-height: 20.8px; color: #111827; margin: 0;'>" + new Date(eventToBeAccepted.startDateTime) + "</p>"; */
            html += `       <p style='font-family: Poppins; font-size: 14px; line-height: 20.8px; color: #111827; margin: 0;'>${formatDateTimeLanguageSpecificService(reduxSelectedLanguage, eventToBeAccepted.startDateTime)}</p>`;
            html += "   </div>";
            html += "   <div style='margin-bottom: 1.5rem; background-color: #FBEFEF; border-radius: 8px; text-align: left; padding: 15px;'>";
            html += `       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem; color: #CF132A'>${reduxLanguageTranslations != null ? reduxLanguageTranslations["confirmationEmailRemarkLabel"] : "Remarque"}</h5>`;
            html += `       <p style='margin: 0; font-family: Poppins; font-size: 14px;'>${reduxLanguageTranslations != null ? reduxLanguageTranslations["confirmationEmailRemarkSectionText"] : "You will receive second email confirmation from the agency with the electronic invitation to add on your agenda. Later, if you're not able to attend to the visit appointment please come back on this email and click on the button below OR call the agency at +32 02 487 878"}</p>`;
            html += "   </div>";
            html += "   <div style='display: flex; align-items: center; justify-content: space-between; font-family: Poppins'>"
            html += `       <a href='#' style='margin-right: 10px; border: 1px solid #111827; text-decoration: none; width: 50%; margin:auto; padding: 9px 10px; border-radius: 8px; text-align: center; color: #111827; font-size: 14px'>${reduxLanguageTranslations != null ? reduxLanguageTranslations["confirmationEmailCancelVisitButtonText"] : "Cancel the Visit"}</a>`;
            //html += "       <a href='#' style='background-color: #274B97; color: white; text-decoration: none; width: 100%; padding: 10px; border-radius: 8px; text-align: center;font-size: 14px'>Reschedule the Visit</a>" formatDateTimeLanguageSpecificService();
            html += "   </div>"
            html += "</div> ";


            let email = "";
            if (eventToBeAccepted.contacts[0].privateEmail != undefined && eventToBeAccepted.contacts[0].privateEmail != "") {
                email = eventToBeAccepted.contacts[0].privateEmail;
            }
            else {
                email = eventToBeAccepted.contacts[0].businessEmail;
            }
            let sendTo = email;

            let objEmail = {
                emailTo: sendTo,
                body: html,
                subject: subject
            }

            const url = variables.API_URL + `Email/SendEmail?`;

            const response = await axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
            if (response.data) {
                var resp = response.data;
                setEventToBeAccepted(null);
                setEstateDetailForEventToBeAccepted(null);
                setShowCalendarLoader(true);
                handleClose();
                let calendarViewDetails = reduxCalendarView;
                getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        /*axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                var resp = response.data;
                setEventToBeAccepted(null);
                setEstateDetailForEventToBeAccepted(null);
                setShowCalendarLoader(true);
                handleClose();
                let calendarViewDetails = reduxCalendarView;
                getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });*/
    }

    const saveEventConfigurations = (config) => {

        let url = variables.API_URL + `InviteeConfiguration/SaveConfigurations?`;
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        axios.post(url, JSON.stringify(config), jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                //handleClose();
                closeShowModal();
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const saveBookableUntilLimit = async () => {

        let url = "";
        if (reduxBookAbleUntil && reduxBookAbleUntil.label && reduxBookAbleUntil.value) {
            url = variables.API_URL + `Calendar/SaveBookableUntilLimitForEstate?clientId=${clientId}&estateId=${reduxProperty.id}&type=${reduxBookAbleUntil.label}&value=${reduxBookAbleUntil.value}`;
        }
        else {
            url = variables.API_URL + `Calendar/SaveBookableUntilLimitForEstate?clientId=${clientId}&estateId=${reduxProperty.id}`;
        }

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        await axios.post(url, {}, jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                const value = response.data;
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    // new event save in whise & local db
    const saveNewWhiseEvent = async (e) => {
        setGetAvilableEventSlotFromRedux(getAvilableEventSlotFromRedux);
        e.target.setAttribute("disabled", true);
        e.target.style.cursor = "progress";
        document.querySelector("body").style.cursor = "progress";
        document.body.style.pointerEvents = "none"; // disables clicks everywhere
        setShowCalendarLoader(true);

        try {
            if (contactId > 0) {
                if (reduxEventDetail.event != null && reduxEventDetail.availableHours != null) {

                    let agentIds = reduxAgent.map(item => { return item.value });
                    let address = "";
                    if (reduxEventDetail.event.EventAddress == "property") {
                        address += reduxProperty.address == undefined ? "" : reduxProperty.address + " ";
                        address += reduxProperty.number == undefined ? "" : reduxProperty.number + ", ";
                        address += reduxProperty.zip == undefined ? "" : reduxProperty.zip;
                        address += reduxProperty.city == undefined ? "" : " " + reduxProperty.city;
                    }
                    else {
                        address += whiseOffice.address == undefined ? "" : whiseOffice.address + " ";
                        address += whiseOffice.number == undefined ? "" : whiseOffice.number + ", ";
                        address += whiseOffice.zip == undefined ? "" : whiseOffice.zip;
                        address += whiseOffice.city == undefined ? "" : " " + whiseOffice.city;
                    }

                    let subject = getAction(reduxEventDetail.event.EventType) + ": " + address;

                    // get estate status from db
                    const previousEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

                    let traceExpection = [];
                    let expectionLog = false;
                    let freeSlotInternalIds = []; // store new free slots internal ids
                    let whiseEventIds = [];
                    let freeSlotEventDetail = [];

                    // add action log
                    let actionLogObj = {
                        estateId: reduxProperty.id,
                        clientId: reduxProperty.clientId,
                        actionId: 3,
                        actionStatus: true,
                        performedBy: "agent",
                        metadata: JSON.stringify({
                            internalEventIds: freeSlotInternalIds,
                            creationFreeSlotsCount: reduxEventDetail.availableHours.length,
                            previousEstateStatus: previousEstateStatus,
                            key: "start events creation",
                            description: `${reduxEventDetail.availableHours.length} free slot created`
                        }),
                        parentLogId: null,
                        syncWithWhise: officeSettings.syncEventsToWhise ? true : false,
                        origin: "EU",
                        exception: null
                    }

                   // const getParentIdFromFreeSlotCreation = await addNewActionsLog(actionLogObj);
                    //let parentIdFreeSlotCreate = getParentIdFromFreeSlotCreation.logId

                    //let iteration = 0; // to track loop iteration
                    for (const item of reduxEventDetail.availableHours) {

                        //iteration++; // increment for each slot
                        let bookAbleDateTime = new Date();
                        let itemDateTime = new Date(item.StartDateTime.replace("Z", ""));
                        if (reduxBookAbleUntil) {
                            if (reduxBookAbleUntil.label == "days") {
                                bookAbleDateTime.setDate(bookAbleDateTime.getDate() + parseInt(reduxBookAbleUntil.value, 10));
                            }
                            else {
                                bookAbleDateTime.setHours(bookAbleDateTime.getHours() + parseInt(reduxBookAbleUntil.value, 10));
                            }
                        }

                        if (itemDateTime > bookAbleDateTime) {
                            try {

                                let configration = {
                                    CalendarActionId: reduxEventDetail.event.EventType,
                                    StartDateTime: item.StartDateTime, // adjustedStart.toISOString(), //
                                    EndDateTime: item.EndDateTime, //adjustedEnd.toISOString(), //
                                    AllDay: item.AllDay,
                                    Private: false,
                                    Subject: subject,
                                    UserIds: agentIds,
                                    EstateIds: [reduxProperty.id],
                                    ContactIds: [+contactId],
                                    Description1: "SmartCalendar Db Event"
                                };

                                if (officeSettings.syncEventsToWhise) {
                                    configration["Description1"] = "SmartCalendar Whise Event";
                                    await addWhiseCalenderEvent(configration, traceExpection, freeSlotInternalIds, whiseEventIds);
                                } else {
                                    configration["Description1"] = "SmartCalendar Db Event";
                                    await addCalenderEventInDB(configration, traceExpection, freeSlotInternalIds, actionLogObj);
                                }

                                configration.internalEventId = freeSlotInternalIds[freeSlotInternalIds.length - 1];
                                configration.whiseEventIds = whiseEventIds[whiseEventIds.length - 1];
                                freeSlotEventDetail.push(configration);

                                //actionLogObj.parentLogId = parentIdFreeSlotCreate;
                                //actionLogObj.metadata = JSON.stringify(configration);
                                //addNewActionsLog(actionLogObj); // add action log


                            } catch (error) {

                                let errFun = traceExpection.at(-1);

                                // get estate status from db
                                const newEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

                                // update action log object
                                actionLogObj.actionStatus = false;
                                actionLogObj.metadata = JSON.stringify({
                                    internalEventIds: freeSlotInternalIds,
                                    creationFreeSlotsCount: reduxEventDetail.availableHours.length,
                                    previousEstateStatus: previousEstateStatus,
                                    newEstateStatus: newEstateStatus,
                                });
                                actionLogObj.exception = `${JSON.stringify({ message: error.message, stack: error.stack, expectionFun: errFun })}`;

                                addNewActionsLog(actionLogObj); // add action log
                                updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });
                                closeShowModal();
                                expectionLog = true;
                            }
                        }
                    }

                    saveBookableUntilLimit();

                    const checkIsEstateAlreadyExistInDB = reduxActiveEstateList.includes(reduxProperty.id); //

                    const updateActiveEstateList = checkIsEstateAlreadyExistInDB ? reduxActiveEstateList : reduxActiveEstateList.concat([reduxProperty.id]);

                    dispatch(setActiveEstateList(updateActiveEstateList));

                    setActivatedEstates(prev => [...prev, reduxProperty.id]); // estate status is active

                    // remove event detail in redux after create new free slot events
                    removeEventDetailInReduxAfterCreateNewFreeSlotEvents();

                    // latest get all estate status
                    if (clientEstates.length > 0) {
                        getEstateStatusListFromDB(clientEstates);
                    }

                    // render the calendar view for new events
                    if (reduxCalendarView) {
                        let calendarViewDetails = reduxCalendarView;
                        getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view, updateActiveEstateList);
                    }

                    setShowCalendarLoader(false); // remove loader
                    e.target.removeAttribute("disabled");
                    e.target.style.cursor = "";
                    document.querySelector("body").style.cursor = "";
                    document.body.style.pointerEvents = "";

                    // property level setting save new feature
                    const payloadEstateAndOfficeAutomaticAccept = {
                        "settingType": "estate",
                        "clientId": reduxProperty.clientId,
                        "estateId": reduxProperty.id,
                        "officeId": reduxProperty.officeId,
                        "setting": {
                            "automaticSlotAcceptation": automaticSlotAccept
                        }
                    }

                    await saveAutomaticAcceptSetting(payloadEstateAndOfficeAutomaticAccept);

                    // if any expection raise then can't call to this function
                    if (expectionLog == false) {
                        // get estate status from db
                        const newEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

                        // update action log
                        //actionLogObj.parentLogId = parentIdFreeSlotCreate;
                        actionLogObj.metadata = JSON.stringify({
                            internalEventIds: freeSlotInternalIds,
                            creationFreeSlotsCount: reduxEventDetail.availableHours.length,
                            oldEstateStatus: previousEstateStatus,
                            newEstateStatus: newEstateStatus,
                            eventDetail: freeSlotEventDetail,
                            key: `${reduxEventDetail.availableHours.length} Free slots successfully add on the whise and database.`
                        });

                        addNewActionsLog(actionLogObj);
                    }

                    if (!checkIsEstateAlreadyExistInDB) {
                        await getFutureThreeMonthWhiseEvents(reduxProperty.id, updateActiveEstateList); // call future 3 month events
                        await getPastOneYearConfirmedWhiseEvents(reduxProperty.id, updateActiveEstateList); // call past 1 year confirmed events
                        console.log("call to get all past and future events");
                    }
                }
            }
        } catch (error) {
            console.log(error);
            setShowCalendarLoader(false);
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";
            document.querySelector("body").style.cursor = "";
            document.body.style.pointerEvents = "";

            // action log
            const actionLogObj = {
                estateId: reduxProperty.id,
                clientId: reduxProperty.clientId,
                actionId: 3,
                actionStatus: false,
                performedBy: "agent",
                metadata: JSON.stringify({
                    key: "saveNewWhiseEvent outer exception",
                    exception: error.message
                }),
                parentLogId: null,
                syncWithWhise: officeSettings.syncEventsToWhise ? true : false,
                origin: "EU",
                exception: `${JSON.stringify({ message: error.message, stack: error.stack })}`
            };
            addNewActionsLog(actionLogObj);
            updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });
        }
    }

    const addCalenderEventInDB = async (body, traceExpection, freeSlotInternalIds, actionLogObj) => {

        let url = variables.API_URL + "LocalEvents/SaveEventInDatabase?";
        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };
        body.ClientId = clientId;
        //console.log(body);
        try {
            const response = await axios.post(url, body, config);
            if (response.data.calendarId != undefined) {
                if (reduxEventDetail.invitee != null) {
                    let configuration = {
                        Name: reduxEventDetail.invitee.Name,
                        FirstName: reduxEventDetail.invitee.FirstName,
                        Email: reduxEventDetail.invitee.Email,
                        Mobile: reduxEventDetail.invitee.Mobile,
                        Questions: reduxEventDetail.invitee.Question,
                        Documents: reduxEventDetail.invitee.Documents,
                        AgentRecap: reduxEventDetail.invitee.AgentOnSiteRecap,
                        EventId: response.data.calendarId,
                        ContactId: +contactId,
                    };
                    saveEventConfigurations(configuration);
                }
                // new create free slot interval event id
                freeSlotInternalIds.push(response.data.calendarId);
            } else {
                traceExpection.push("LocalEvents/SaveEventInDatabase?");

                // update action log object
                actionLogObj.actionStatus = false;
                actionLogObj.metadata = JSON.stringify({
                    key: "Save event in local DB failed",
                    response: response.data
                });
                actionLogObj.exception = JSON.stringify(response.data);
                addNewActionsLog(actionLogObj); // add action log
                updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });

                throw new Error(JSON.stringify(response.data)); // throw error to parent fun
            }
        } catch (error) {
            showMessage("error", error);
            traceExpection.push("LocalEvents/SaveEventInDatabase?");

            // update action log object
            actionLogObj.actionStatus = false;
            actionLogObj.metadata = JSON.stringify({
                key: "Save event in local DB exception",
                exception: error.message
            });
            actionLogObj.exception = `${JSON.stringify({ message: error.message, stack: error.stack })}`;
            addNewActionsLog(actionLogObj); // add action log
            updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });

            throw new Error(JSON.stringify(error.message)); // throw error to parent fun
        }
    }

    const clickHandlerEventPreview = async (e) => {
        let eventDetail = e.event.extendedProps;
        setPreviewEventDetail(eventDetail)
        setShowModal(true);
        setPreviewEvent(true);
    }

    const changeHandlerSearchByEstateId = (e) => {
        let value = e.target.value;
        let isnum = /^\d+$/.test(value);

        setShowPropertiesLoader(true);

        let filteredList = clientEstates;

        if (value !== "" && isnum == true) {
            setEstateId(value);
            let filteredEstatesList = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(value);
            })
            setFilteredEstates(filteredEstatesList);
            setShowPropertiesLoader(false);
        }
        else if (value == "") {
            if (estateSearch != "") {
                let listAfterFirstFilter = filteredList.filter(item => {
                    let itemPrice = item.price != undefined ? item.price + "" : "";
                    let city = item.city != undefined ? item.city.toLowerCase() : "";
                    let address = item.address != undefined ? item.address.toLowerCase() : "";
                    let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                    let number = item.number != undefined ? item.number.toLowerCase() : "";
                    return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
                });

                filteredList = listAfterFirstFilter;
            }
            if (purposeStatusId != "") {
                let listAfterSecondFilter = filteredList.filter(item => {
                    return item.purpose.id == purposeStatusId;
                });
                filteredList = listAfterSecondFilter;
            }
            if (displayStatusIds.length > 0) {
                const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
                let listAfterThirdFilter = filteredList.filter(item =>
                    modifyDisplayStausSelectedIds.includes(item.displayStatusId)
                );
                filteredList = listAfterThirdFilter;
            }
            if (selectOffice != "") {
                let listAfterFourFilter = filteredList.filter(item => {
                    return item.officeId == selectOffice;
                })
                filteredList = listAfterFourFilter;
            }
            setEstateId("");
            setFilteredEstates(filteredList);
            setShowPropertiesLoader(false);
        }
    }

    const changeHandlerSearchByEstateProps = (e) => {
        let value = e.target.value.toLowerCase();

        let filteredList = clientEstates;
        if (estateId != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterFirstFilter
        }
        if (purposeStatusId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                return item.purpose.id == purposeStatusId;
            });
            filteredList = listAfterSecondFilter;
        }
        if (displayStatusIds.length > 0) {
            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let listAfterThirdFilter = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            filteredList = listAfterThirdFilter;
        }
        if (selectOffice != "") {
            let listAfterFourFilter = filteredList.filter(item => {
                return item.officeId == selectOffice;
            })
            filteredList = listAfterFourFilter;
        }

        if (value !== "") {
            setEstateSearch(value);
            let filteredEstatesList = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(value) || address.includes(value) || itemPrice.includes(value) || zip.includes(value) || number.includes(value);
            })
            setFilteredEstates(filteredEstatesList);
        }
        else {
            setEstateSearch("");
            setFilteredEstates(filteredList);
        }
    }

    const changeHandlerPurposeStatusFilter = (e) => {
        let value = e.target.value;

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        if (displayStatusIds.length > 0) {
            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let listAfterThirdFilter = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            filteredList = listAfterThirdFilter;
        }
        if (selectOffice != "") {
            let listAfterFourFilter = filteredList.filter(item => {
                return item.officeId == selectOffice;
            })
            filteredList = listAfterFourFilter;
        }

        if (value != "") {
            setPurposeStatusId(value);
            let filteredEstatesList = filteredList.filter(item => {
                return item.purpose.id == value;
            })
            setFilteredEstates(filteredEstatesList);
            if (filteredEstatesList.length > 0) {
                setSelectedProperty(filteredEstatesList[0]);
                dispatch(setselectedproperty(filteredEstatesList[0]));
            }
        }
        else {
            setPurposeStatusId("");
            setFilteredEstates(filteredList);
            if (filteredList.length > 0) {
                setSelectedProperty(filteredList[0]);
                dispatch(setselectedproperty(filteredList[0]));
            }
        }
    }

    const changeHandlerDisplayStatusFilter = (event) => {
        /* setDisplayStatusId(event);*/
        const value = event;

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        if (purposeStatusId != "") {
            let listAfterThirdFilter = filteredList.filter(item => {
                return item.purpose.id == purposeStatusId;
            });
            filteredList = listAfterThirdFilter;
        }
        if (selectOffice != "") {
            let listAfterFourFilter = filteredList.filter(item => {
                return item.officeId == selectOffice;
            })
            filteredList = listAfterFourFilter;
        }

        if (value.length > 0) {
            /*let filteredEstatesList = filteredList.filter(item => {
                return item.displayStatusId == value;
            })*/
            setDisplayStatusIds(value);
            const modifyDisplayStausSelectedIds = value.map((item) => +item.value); // [1,2,3]
            let filteredEstatesList = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            setFilteredEstates(filteredEstatesList);
        }
        else {
            setDisplayStatusIds([]);
            setFilteredEstates(filteredList);

        }
    }

    const changehandlerSelectOfficeFilter = (e) => {
        const value = e.target.value;

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        if (displayStatusIds.length > 0) {
            const modifyDisplayStausSelectedIds = displayStatusIds.map((item) => +item.value); // [1,2,3]
            let listAfterThirdFilter = filteredList.filter(item =>
                modifyDisplayStausSelectedIds.includes(item.displayStatusId)
            );
            filteredList = listAfterThirdFilter;
        }
        if (purposeStatusId != "") {
            let filteredEstatesList = filteredList.filter(item => {
                return item.purpose.id == purposeStatusId;
            })
            setFilteredEstates(filteredEstatesList);
            filteredList = filteredEstatesList;
        }

        if (value != "") {
            setSelectOffice(value);
            let filteredEstatesList = filteredList.filter(item => {
                return item.officeId == value;
            })
            setFilteredEstates(filteredEstatesList);
            filteredList = filteredEstatesList;
        }
        else {
            setSelectOffice("");
            setFilteredEstates(filteredList);
        }
    }

    const handlerClearEstateFilter = (e) => {
        setDisplayStatusIds([]);
        setPurposeStatusId("");
        setSelectOffice("");

        let filteredList = clientEstates;
        if (estateSearch != "") {
            let listAfterFirstFilter = filteredList.filter(item => {
                let itemPrice = item.price != undefined ? item.price + "" : "";
                let city = item.city != undefined ? item.city.toLowerCase() : "";
                let address = item.address != undefined ? item.address.toLowerCase() : "";
                let zip = item.zip != undefined ? item.zip.toLowerCase() : "";
                let number = item.number != undefined ? item.number.toLowerCase() : "";
                return city.includes(estateSearch) || address.includes(estateSearch) || itemPrice.includes(estateSearch) || zip.includes(estateSearch) || number.includes(estateSearch);
            });
            filteredList = listAfterFirstFilter;
        }
        if (estateId != "") {
            let listAfterSecondFilter = filteredList.filter(item => {
                let itemEstateId = item.id + "";
                return itemEstateId.includes(estateId);
            });
            filteredList = listAfterSecondFilter;
        }
        setFilteredEstates(filteredList);
    }

    const formatPrice = (price, symbol) => {
        let formattedPrice = new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR' }).format(price,);
        return formattedPrice;
    }

    const getWhiseOffices = () => {
        let url = "https://api.whise.eu/v1/admin/offices/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${whiseUserToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, { "clientId": clientId }, config)
            .then(response => {
                if (response.data.offices != undefined) {
                    const updateOfficeList = response.data.offices.map((item) => ({ ...item, Id: item.id }));
                    setOfficeList(updateOfficeList);
                    //setOfficeList(response.data.offices);
                    setSelectOffice(response.data.offices[0].id);
                    var _filteredOffice = updateOfficeList.filter((item) => { return item.id == officeId });
                    setWhiseOffice(_filteredOffice[0]);
                    setIsOfficesLoaded(true);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const handleDropdownToggle = (e, dropdownId, property) => {
        e.stopPropagation();
        handlerPropertyClick(property);
        setOpenDropdownId(prevId => prevId === dropdownId ? null : dropdownId); // Toggle dropdown visibility
        dispatch(setRenderApp(reduxRenderApp + 1));  // triggers fresh data
    };

    //languages save in redux store
    const getAllLanguage = () => {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetAllLanguages`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let getLanguages = response.data;
                dispatch(setlanguages(getLanguages));
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const copToClipBoard = (link) => {
        navigator.clipboard.writeText(link);
    }

    const editEstateConfigurations = (e, estateId) => {
        setIsEstateConfigurationsEdit(true);
        setShowModal(true);
    }

    // open edit estate config modal (equestions/ documents)
    useEffect(() => {
        if (reduxShowEditEstateConfigModal) {
            editEstateConfigurations();
        }
    }, [reduxShowEditEstateConfigModal]);

    const GetActivatedEstateIds = useCallback(async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `Estate/GetActivatedEstateIds?clientId=${clientId}`;

        try {
            const response = await axios.get(url, jsonconfig);
            const ids = response.data;
            dispatch(setActiveEstateList(ids));
            //console.log(ids);
            //(setActiveEstateList(updatedList));
            if (Array.isArray(ids)) {
                setActivatedEstates(prev => [...new Set([...prev, ...ids])]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showMessage("error", error);
        }
    }, [clientId, user.tokenValue]);

    useEffect(() => {
        if (clientId) {
            GetActivatedEstateIds();
            //GetSuspendedEstateIds();
        }
    }, [clientId, GetActivatedEstateIds]);

    useEffect(() => {
        if (eventToBeAccepted != null && estateDetailForEventToBeAccepted != null) {
            setShowModal(false);
            setShowCalendarLoader(true);
            let confirmedId = confirmedIds[0];
            if (estateDetailForEventToBeAccepted[0].purpose.id === 2) {
                confirmedId = confirmedIds[1];
            }

            let address = "";
            address += estateDetailForEventToBeAccepted[0].address == undefined ? "" : estateDetailForEventToBeAccepted[0].address + " ";
            address += estateDetailForEventToBeAccepted[0].number == undefined ? "" : estateDetailForEventToBeAccepted[0].number + ", ";
            address += estateDetailForEventToBeAccepted[0].zip == undefined ? "" : estateDetailForEventToBeAccepted[0].zip;
            address += estateDetailForEventToBeAccepted[0].city == undefined ? "" : " " + estateDetailForEventToBeAccepted[0].city;

            let subject = getAction(confirmedId) + ": " + address;

            let configration = {
                "CalendarActionId": confirmedId,
                "StartDateTime": eventToBeAccepted.startDateTime,
                "EndDateTime": eventToBeAccepted.endDateTime,
                "AllDay": "false",
                "Private": false,
                "subject": subject, //"private",
                "UserIds": [eventToBeAccepted.users[0].userId],
                "EstateIds": [estateDetailForEventToBeAccepted[0].id],
                "ContactIds": [eventToBeAccepted.contacts[0].contactId]
            }
            //deleteWhiseCalendarEvent(eventToBeAccepted.eventId, configration);
            deleteWhiseCalendarEvent(eventToBeAccepted, configration);
        }
    }, [eventToBeAccepted, estateDetailForEventToBeAccepted]);

    useEffect(() => {
        setShowCalendarLoader(true);

        if (clientToken != "" && freeSlotIds.length > 0 && selectedProperty) {

            if (reduxCalendarView) {
                let calendarViewDetails = reduxCalendarView;
                getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view, reduxActiveEstateList);
            }
            else {
                getWhiseCalenderEvents("default");
            }
        }
    }, [clientToken, selectedAgents, selectedProperty, selectedStatuses, whiseCalendarEventId, freeSlotIds]);

    useEffect(() => {
        if (whiseUserToken && reduxClientToken != null) {
            setClientToken(reduxClientToken);
            getAgents(reduxClientToken);
            getEstateIdsHavingConfigSaved();
        }
        if (reduxSelectedLanguage && reduxClientToken != null && freeSlotIds.length > 0 && selectOffice != "") {
            getClientWhiseEstatesList(reduxClientToken);
        }
    }, [whiseUserToken, reduxClientToken, reduxSelectedLanguage, freeSlotIds, selectOffice])

    //this code will execute only one time to load whise events of all estates of a client in Database
    useEffect(() => {
        const syncEvents = async () => {
            if (clientEstates.length > 0 && freeSlotIds.length > 0 && tobeConfirmedIds.length > 0 && confirmedIds.length > 0 && user) {
                if (user.user.firstSynchronization) {
                    return;
                }

                setShowSynchingLoader(true);

                let savedCalendarActions = [...new Set([...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds])];
                //let savedCalendarActions = [...new Set([...freeSlotIds])];
                const startDate = toLocalISOString(new Date());

                for (const estate of clientEstates) {
                    let eventLimit = 300;
                    let pageOffset = 0;
                    let listOfEvents = [];

                    const _response = await fetchEventsForFirstSynchronization(startDate, estate.id, savedCalendarActions, estate, eventLimit, pageOffset);
                    console.log(_response);
                    if (_response.totalCount !== undefined && _response.totalCount > 300) {
                        listOfEvents.push(..._response.calendars);
                        const pages = Math.ceil(_response.totalCount / 300);
                        for (let i = 1; i < pages; i++) {
                            pageOffset = eventLimit * i + 1;
                            const _eventResponse = await fetchEventsForFirstSynchronization(startDate, estate.id, savedCalendarActions, estate, eventLimit, pageOffset);
                            if (_eventResponse.calendars?.length > 0) {
                                listOfEvents.push(..._eventResponse.calendars);
                            }
                        }
                    } else if (_response.calendars?.length > 0) {
                        listOfEvents.push(..._response.calendars);
                    }

                    /* for (const event of listOfEvents) {
                         if (event.estates.length > 0) {
                             event.estates[0] = estate;
                         }
                         await pushEventInDB(event[0]);
                     }*/

                    /*console.log(listOfEvents);*/

                    const addClientIdInListOfEvents = listOfEvents.map((item) => ({ ...item, clientId: +clientId }));
                    //await pushEventInDB(listOfEvents);
                    await dumpEventsInLocalDBOnFirstSynchronization(addClientIdInListOfEvents);
                }

                // all done
                await updateSynchronizationFlag();
            }
        };

        syncEvents();
    }, [clientEstates, freeSlotIds, tobeConfirmedIds, confirmedIds, user]);

    const fetchEventsForFirstSynchronization = async (minDate, estateId, actionIds, estate, eventLimit, pageOffset) => {
        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            "Filter": {
                "DateTimeRange": {
                    "Min": minDate
                },
                "EstateIds": [estateId],
                "CalendarActionIds": actionIds
            },
            "Page": {
                "Limit": eventLimit,
                "Offset": pageOffset
            }
        };

        let response = await axios.post(url, body, config);

        return response.data;
    }

    const dumpEventsInLocalDBOnFirstSynchronization = async (allWhiseEventsList) => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `Calendar/DumpEventsOnFirstSync`;

        try {
            const response = await axios.post(url, allWhiseEventsList, jsonconfig);
            const message = response.data;
            console.log(message);
        } catch (error) {
            console.error('Error dump events in local db on first sync', error);
            showMessage("error", error);
        }
    }

    const updateSynchronizationFlag = async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `User/UpdateSynchronizationFlag?clientId=${clientId}`;

        try {
            const response = await axios.post(url, {}, jsonconfig);
            const message = response.data;
            if (message == "updated") {
                const _user = {
                    ...user,
                    user: {
                        ...user.user,
                        firstSynchronization: true
                    }
                };
                dispatch(login(_user));
                setShowCalendarLoader(false);
                setShowSynchingLoader(false);
            }
        } catch (error) {
            console.error('Error while updating synchronization flag:', error);
            showMessage("error", error);
        }
    }

    useEffect(() => {
        if (actions != null && actions != undefined) {
            setCalendarActions(actions);
        }
    }, [actions])

    useEffect(() => {
        if (container != null) {
            let contHeight = container.current.offsetHeight;
            setHeight(contHeight);
        }
    }, [container]);

    const getContactWaitingList = async (estateId) => {
        try {
            setIsLoadingDataGrid(true);
            /*const url = `${variables.API_URL}Calendar/GetWaitingListRecords?estateId=${estateId}`*/
            //const url = `${variables.API_URL}Calendar/GetWaitingListRecords?estateId=${estateId}&search=${filterDataGrid !== "" ? filterDataGrid : null}&status=${statusDataGrid}&pageNumber=${pageDataGrid + 1}&pageSize=${pageSizeDataGrid}`;

            let url;

            if (tabBtnActiveWaitingList == 1) {
                url = `${variables.API_URL}Calendar/GetWaitingListRecords?estateId=${estateId}&calendarActionIdToBeConfirm=${tobeConfirmedIds[0]}&calendarActionIdConfirmed=${confirmedIds[0]}&search=${filterDataGrid !== "" ? filterDataGrid : null}&status=${statusDataGrid}&pageNumber=${pageDataGrid + 1}&pageSize=${pageSizeDataGrid}`;
            } else if (tabBtnActiveWaitingList == 2 || tabBtnActiveWaitingList == 3) {
                url = `${variables.API_URL}Calendar/GetToBeConfirmOrConfirmedRecords?estateId=${estateId}&calendarActionIdToBeConfirm=${tobeConfirmedIds[0]}&calendarActionIdConfirmed=${confirmedIds[0]}&isToBeConfirm=${tabBtnActiveWaitingList == 2 ? true : false}&search=${filterDataGrid !== "" ? filterDataGrid : null}&pageNumber=${pageDataGrid + 1}&pageSize=${pageSizeDataGrid}`;
            } else if (tabBtnActiveWaitingList == 4) {
                url = `${variables.API_URL}Calendar/GetBookingSiteAcessLogs?estateId=${estateId}&calendarActionIdToBeConfirm=${tobeConfirmedIds[0]}&calendarActionIdConfirmed=${confirmedIds[0]}&search=${filterDataGrid !== "" ? filterDataGrid : null}&pageNumber=${pageDataGrid + 1}&pageSize=${pageSizeDataGrid}`;
            }

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            const response = await axios.get(url, config);
            if (response.data) {

                if (response.data.status == ("No record found")) {
                    setContactWaitingListData([]);
                    setIsLoadingDataGrid(false);
                    return;
                }

                const formatedData = response.data.records.map((item, index) => {
                    const contactTitleId = titleSafeParse(item.title); // JSON.parse(item.title); => we handle empty {}, therefore, we use this function
                    let contactTitle;
                    if (contactTitleId != null && contactTitlesList.length > 0) {
                        const filterContactTitle = contactTitlesList.filter(contactTitleItem => contactTitleItem.value == (contactTitleId.Id || contactTitleId));
                        contactTitle = filterContactTitle.length > 0 ? reduxSelectedLanguage == "en-GB" ? filterContactTitle[0].labelEn : reduxSelectedLanguage == "fr-BE" ? filterContactTitle[0].labelFr : filterContactTitle[0].labelNl : "";
                    } else {
                        contactTitle = "";
                    }

                    return {
                        ...item,
                        id: index + 1,
                        dateDescription: format(new Date(item.dateDescription || item.eventStartDate || item.accessDateTime), 'dd/MM/yyyy - HH:mm'),
                        title: contactTitle // //parsedTitle.label
                    };
                });

                setContactWaitingListData(formatedData);
                setTotalRecordDataGrid(response.data.filteredTotalRecordsInDB);
                setPageSizeDataGrid(response.data.pageSize);
                setWaitingListGridAllDataFromApi(response.data);

                if (response.data.accessLogsTotalCount != 0 || response.data.confirmedEventsTotalCount != 0 || response.data.toBeConfirmedEventsTotalCount != 0 || response.data.waitingListTotalCount != 0) {
                    setWaitListBtnEnabled(true);
                } else {
                    setWaitListBtnEnabled(false);
                }

                // 1-second loading delay => remove jerk
                setTimeout(() => {
                    setIsLoadingDataGrid(false);
                }, 1000);

                /* setIsLoadingDataGrid(false);*/
            }

        } catch (error) {
            console.error(error);
            setIsLoadingDataGrid(false);
        }

    }

    useEffect(() => {
        if (reduxProperty != null && reduxProperty.purpose.id == purposeStatusId) {
            setSelectedProperty(reduxProperty);
            getContactWaitingList(reduxProperty.id); // get waiting list data
        }
        else if ((reduxProperty == null || reduxProperty.purpose.id != purposeStatusId) && filteredEstates.length > 0) {
            setSelectedProperty(current => filteredEstates[0]);
            dispatch(setselectedproperty(filteredEstates[0]));
            getContactWaitingList(filteredEstates[0].id); // get waiting list data
        }

    }, [filteredEstates]);

    const getEstateStatusListFromDB = async (allEstates) => {

        try {
            const url = `${variables.API_URL}LocalEvents/GetBulkEstateStatus`;

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            const getAllEstateIds = allEstates.map(estate => estate.id);

            const body = {
                clientId: allEstates[0].clientId,
                estateIds: getAllEstateIds
            }

            const response = await axios.post(url, body, config);
            if (response.data) {
                setEstateStatusListFromDB(response.data);
                dispatch(setEstateStatusList(response.data));
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        // getOfficeSettings();
        getAllLanguage();
        if (reduxStatus != undefined && reduxStatus !== null && reduxStatus.length > 0) {
            setSelectedStatuses(reduxStatus);
        }
        if (reduxAgent != undefined && reduxAgent != null) {
            setSelectedAgents(reduxAgent);
        }
        setTimeout(() => {
            if (reduxIsSidebarCollapsed == false) {
                dispatch(setSidebarCollapsed(true));
            }
            //setIsPropertiesCollapsed(true);
        }, 5000);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openDropdownId !== null && !event.target.closest('.estate-drop-menu')) {
                setOpenDropdownId(null); // Close dropdown when clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownId]);

    const GetSuspendedEstateIds = async () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `Calendar/GetSuspendedEstateIds?clientId=${clientId}`;

        try {
            const response = await axios.get(url, jsonconfig);
            const ids = response.data;

            if (Array.isArray(ids)) {
                setSuspendedEstates(prev => [...new Set([...prev, ...ids])]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showMessage("error", error);
        }
    }

    const markEstateActiveInDB = async (estate) => {

        let url = variables.API_URL + "Estate/ActivateEstateInDB?";
        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        try {
            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);
            const response = await axios.post(url, estate, config); // replace body => estate
            setShowCalendarLoader(true);
            if (response.status === 200) {
                setActivatedEstates(prev => [...prev, estate.id]);

                // check active estate in db and dump in redux store
                const checkIsEstateAlreadyExistInDB = reduxActiveEstateList.includes(estate.id);
                const updateActiveEstateList = checkIsEstateAlreadyExistInDB ? reduxActiveEstateList : reduxActiveEstateList.concat([estate.id]);
                dispatch(setActiveEstateList(updateActiveEstateList));

                // update latest status estate purpose button
                getEstatePurposeConfigJobStatusBtn(estate.id);

                // latest get all estate status
                if (clientEstates.length > 0) {
                    getEstateStatusListFromDB(clientEstates);
                }

                // Await the inner async call and catch any errors
                await dumpWhiseEventsOnEstateActivation(estate.id, updateActiveEstateList);

                // get estate status from db
                const newEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: true,
                    estateId: +estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": false,
                        "previousPropertyStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": true,
                        "newPropertyStatus": `${newEstateStatus}`,
                        "description": `Estate status is change`,
                        "key": `Estate status is change`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: false,
                    origin: "EU",
                    exception: null
                }

                // add action log
                addNewActionsLog(actionLogObj);
            } else {
                showMessage("error", "Unexpected response from server.");
                setShowCalendarLoader(false);
                // get estate status from db
                const previousEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: false,
                    estateId: +estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": false,
                        "previousPropertyStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": true,
                        "newPropertyStatus": "",
                        "description": `Estate status is change`,
                        "key": `Estate status is change`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: false,
                    origin: "EU",
                    exception: "Unexpected response from server."
                }

                // add action log
                addNewActionsLog(actionLogObj);
                updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });
            }
        } catch (error) {
            console.error('Error activating estate:', error);
            showMessage("error", "Error activating estate: " + error.message);
            setShowCalendarLoader(false);
            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

            // object action log
            const actionLogObj = {
                actionId: 1,
                actionStatus: false,
                estateId: +estate.id,
                clientId: +estate.clientId,
                metadata: JSON.stringify({
                    "previousSmartCalendarStatus": false,
                    "previousPropertyStatus": `${previousEstateStatus}`,
                    "newSmartCalendarStatus": true,
                    "newPropertyStatus": "",
                    "description": `Estate status is change`,
                    "key": `Estate status is change`
                }),
                performedBy: "agent",
                parentLogId: null,
                syncWithWhise: false,
                origin: "EU",
                exception: `${JSON.stringify(error)}`
            }

            // add action log
            addNewActionsLog(actionLogObj);
            updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });

        }
    }

    const dumpWhiseEventsOnEstateActivation = async (estateId, activeEstateList) => {
        try {
            let savedCalendarActions = [...new Set([...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds])];
            //let savedCalendarActions = [...new Set([...freeSlotIds])];
            let url = variables.API_URL + `calendar/FetchAndDumpEventsOnEstateActivation`;

            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            const body = {
                ClientId: clientId,
                ActionIds: savedCalendarActions,
                EstateId: estateId
            };
            //console.log(body);
            const response = await axios.post(url, body, config);

            if (response.data === "Success") {
                setShowCalendarLoader(false);
                showMessage("success", "Estate is successfully activated and WHISE events loaded.");

                // render the calendar view for new events
                if (reduxCalendarView) {
                    let calendarViewDetails = reduxCalendarView;
                    getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view, activeEstateList);
                }

            } else {
                showMessage("error", "Unexpected response from server.");
                setShowCalendarLoader(false);
            }
        } catch (error) {
            console.error("Error dumping WHISE events:", error);
            showMessage("error", "Failed to load WHISE events: " + error.message);
            setShowCalendarLoader(false);
        }
    }

    const markEstateDeactiveInDB = async (estate) => {

        try {
            let url = variables.API_URL + `Estate/DeactivateEstateInDB?estateId=${estate.id}`;
            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            let body = {}

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

            const response = await axios.post(url, body, config);

            if (response.status === 200) {

                var activatedList = [...activatedEstates];
                const updatedList = activatedList.filter(id => id !== estate.id);
                setActivatedEstates(updatedList);

                // remove deactiveEstateId form activeEstateList
                let removeSelectEstateFromActiveList = reduxActiveEstateList.filter(item => item != estate.id);
                dispatch(setActiveEstateList(removeSelectEstateFromActiveList));

                // update latest status estate purpose button
                getEstatePurposeConfigJobStatusBtn(estate.id);

                // render the calendar view for new events
                if (reduxCalendarView) {
                    let calendarViewDetails = reduxCalendarView;
                    getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view, removeSelectEstateFromActiveList);
                }

                // latest get all estate status
                if (clientEstates.length > 0) {
                    getEstateStatusListFromDB(clientEstates);
                }

                showMessage("success", response.data);

                // get estate status from db
                const newEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: true,
                    estateId: estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": true,
                        "previousPropertyStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": false,
                        "newPropertyStatus": `${newEstateStatus}`,
                        "description": `Estate status is change`,
                        "key": `Estate status is change`

                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: false,
                    origin: "EU",
                    exception: null
                }

                // add action log
                addNewActionsLog(actionLogObj);

            } else {
                showMessage("error", "Unexpected response from server.");
                setShowCalendarLoader(false);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: false,
                    estateId: estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": true,
                        "previousPropertyStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": false,
                        "newPropertyStatus": "",
                        "description": `Estate status is change`,
                        "key": `Estate status is change`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: false,
                    origin: "EU",
                    exception: "Unexpected response from server."
                }

                // add action log
                addNewActionsLog(actionLogObj);
                updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            showMessage("error", error);

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(reduxProperty.id, reduxProperty.clientId);

            // object action log
            const actionLogObj = {
                actionId: 1,
                actionStatus: false,
                estateId: +estate.id,
                clientId: +estate.clientId,
                metadata: JSON.stringify({
                    "previousSmartCalendarStatus": true,
                    "previousPropertyStatus": `${previousEstateStatus}`,
                    "newSmartCalendarStatus": false,
                    "newPropertyStatus": "",
                    "description": `Estate status is change`,
                    "key": `Estate status is change`
                }),
                performedBy: "agent",
                parentLogId: null,
                syncWithWhise: false,
                origin: "EU",
                exception: `${JSON.stringify(error)}`
            }

            // add action log
            addNewActionsLog(actionLogObj);
            updateParentActionLog({ parentLogId: actionLogObj.parentLogId, metadata: actionLogObj.metadata, exception: actionLogObj.exception });
        }
    }

    const showContactWaitingListModal = () => {
        //setIsLoadingDataGrid(true);
        setStatusDataGrid("Enqueue");
        setContactWaitinglistModalShow(true);
    }

    // open waiting list and events record modal 
    //useEffect(() => {
    //    if (reduxshowWaitingAndEventsModal) {
    //        showContactWaitingListModal();
    //    }
    //}, [reduxshowWaitingAndEventsModal])

    const handleCloseContactWaitingListModal = () => {
        setContactWaitinglistModalShow(false);
        setPageDataGrid(0);
        setPageSizeDataGrid(25);
        setTotalRecordDataGrid(0);
        setStatusDataGrid(null);
        setFilterDataGrid("");
        setFilterSearchEnterkey(false);
        setTabBtnActiveWaitingList("1");
        dispatch(setShowWaitingAndEventsModal(false));
    }

    // open waiting list and events histroy modal
    useEffect(() => {
        if (reduxProperty && contactWaitinglistModalShow) {
            getContactWaitingList(reduxProperty.id); // get waiting list data
        }
    }, [filterSearchEnterkey, pageSizeDataGrid, pageDataGrid, statusDataGrid, tabBtnActiveWaitingList]);

    useEffect(() => {

        // get office setting on priority level
        if (selectOffice != "") {
            const getEstateAndOfficeSetting = async () => {

                let payload = {
                    clientId: clientId,
                    estateId: "12345", // dumy estate id
                    officeId: selectOffice,
                    actionType: "ui",
                    settingType: "office"
                }

                let getEstateAndOfficeSettingStatus = await getEstateAndOfficeSettingAgentsite(payload);
                //console.log(officeSettings);

                if (getEstateAndOfficeSettingStatus.waitingListEnabled.toLowerCase() == "clientdefault") {
                    setWaitingListEnabled(officeSettings.waitingListEnabled);
                    dispatch(setWaitingListStatusEnabled(officeSettings.waitingListEnabled));
                } else if (getEstateAndOfficeSettingStatus.waitingListEnabled.toLowerCase() == "true") {
                    setWaitingListEnabled(true);
                    dispatch(setWaitingListStatusEnabled(true));
                } else {
                    setWaitingListEnabled(false);
                    dispatch(setWaitingListStatusEnabled(false));
                }

            }

            getEstateAndOfficeSetting();
        }

    }, [selectOffice]);

    const getEstatePurposeConfigJobStatusBtn = async (estateId) => {
        try {
            let url = `${variables.API_URL}LocalEvents/GetEstatePurposeConfigIdentification?estateId=${estateId}`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data != undefined) {
                //console.log(response.data[0]);
                setEstateJobStatusBtn(response.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const openModelEstateJobActions = () => {
        setShowEstateJobActionModel(true);
    }

    const closeModelEstateJobActions = (estateId) => {
        setShowEstateJobActionModel(false);

        // update latest status estate purpose button
        getEstatePurposeConfigJobStatusBtn(estateId);

        // render the calendar view for new events
        if (reduxCalendarView) {
            let calendarViewDetails = reduxCalendarView;
            getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view);
        }

        // latest get all estate status
        if (clientEstates.length > 0) {
            getEstateStatusListFromDB(clientEstates);
        }

    }

    useEffect(() => {
        if (reduxFetchLatestRecord && reduxActiveEstateList) {
            // render the calendar view for new events
            if (reduxCalendarView) {
                let calendarViewDetails = reduxCalendarView;
                getWhiseCalenderEvents("onAction", calendarViewDetails.startDate, calendarViewDetails.endDate, calendarViewDetails.view, reduxActiveEstateList);
            }
        }
    }, [reduxFetchLatestRecord, reduxActiveEstateList]);


    return (
        <>
            <div className={`${isPropertiesCollapsed == true ? "ps-4 pe-0" : "px-4"}`}>
                <div className="row">
                    <div className={`${isPropertiesCollapsed == true ? "col-sm-11" : "col-12 col-sm-8 col-md-9 col-lg-9 col-xl-9"}`}>
                        <div className="d-flex align-items-center justify-content-between pb-3">
                            <span className="form-title">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageTitle"] : "Calendar"}
                            </span>
                            <div className="d-flex">
                                <Dropdown.Toggle className={`filter-btn ${showHideCalendarFilter == true ? "dropup" : ""}`}
                                    id="calendarFilter" onClick={showCalendarFilters} >
                                    <img src={filterIcon} className="pe-2" />
                                    <span className="pe-3">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterBtn"] : "Filter"}</span>
                                    {
                                        reduxAgent != null && reduxAgent.length != 0 || reduxStatus != null && reduxStatus !== undefined && reduxStatus.length != 0 ?
                                            //<img src={clearCross} className="me-1" />
                                            <button className="clear-btn" onClick={handlerClearCalenderFilter}>
                                                {reduxLanguageTranslations ? reduxLanguageTranslations["clearFilterButtonLabel"] : "Clear"}
                                                <img src={whiteCross} />
                                            </button>
                                            : <></>
                                    }
                                </Dropdown.Toggle>
                                <button className="site-btn ms-2" onClick={handlerAddSlot}>
                                    <img src={plusIcon} />{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageAddSlotBtn"] : "Add Slot"}
                                </button>
                            </div>
                        </div>
                        <div className={`form-container mb-3 ${showHideCalendarFilter == true ? "" : "d-none"}`}>
                            <div className="row mb-3">
                                <div className="col-md-4 col-12">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0" htmlFor="property">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownPropertyLbl"] : "Property"}</label>
                                        <select className="form-select" id="property" disabled>
                                            {
                                                selectedProperty != null && selectedProperty.id != undefined ?
                                                    <option value={selectedProperty.id}>{selectedProperty.name}</option>
                                                    :
                                                    <></>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0" htmlFor="agent">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentLbl"] : "Agent"}<span>*</span></label>
                                        <select className="form-select" onChange={changeHandlerAgentFilter} value={selectedAgents.length > 0 ? selectedAgents[0].value : ""}>
                                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                                            {
                                                whiseAgents.length > 0 ? whiseAgents.map((item, i) => {
                                                    return (
                                                        <option value={item.id} data-agent={JSON.stringify(item)} key={i}>{item.firstName + " " + item.name}</option>
                                                    )
                                                })
                                                    :
                                                    <></>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0" htmlFor="status">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusLbl"] : "Status"}</label>
                                        <MultiSelect
                                            id="transactionType"
                                            value={selectedStatuses.length > 0 ? selectedStatuses : []}
                                            options={() => {
                                                return [
                                                    { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionFreeSl"] : "Free Slot", value: "1", _freeSlotIds: freeSlotIds },
                                                    { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionToBeConfirm"] : "To be Confirmed", value: "2", beforeConfirmationIds: tobeConfirmedIds },
                                                    { label: reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionConfirmed"] : "Confirmed", value: "3", afterConfirmationIds: confirmedIds }
                                                ]
                                            }}
                                            onChange={handleChangeStatus}
                                            labelledBy="Select an option"
                                            overrideStrings={customMultiSelectLabels}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-end">
                                    <button className="site-btn-transparent" onClick={handleCancelFilter}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownsCancelBtn"] : "Cancel"}</button>
                                    <button className="site-btn ms-3" onClick={handlerSaveFilter}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownsSaveBtn"] : "Save"}</button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Schedular showMessageBox={showMessage} selectedProperty={selectedProperty} calendarRef={calendarRef} calendarEvents={whiseCalendarEvents} tobeConfirmedIds={tobeConfirmedIds}
                                confirmedIds={confirmedIds} freeSlotIds={freeSlotIds} eventClickHandler={clickHandlerEventPreview} selectedAgentsList={selectedAgents} selectedStatusAction={selectedStatuses}
                                showCalendarLoader={showCalendarLoader} getWhiseCalenderEvents={getWhiseCalenderEvents} setShowCalendarLoader={setShowCalendarLoader} currentRange={currentRange}
                                toLocalISOString={toLocalISOString} setEstateListContainEvent={setEstateListContainEvent} setEstateIdsHavingFreeSlotsInFutureOrPast={setEstateIdsHavingFreeSlotsInFutureOrPast}
                                showSynchingLoader={showSynchingLoader}
                            />
                        </div>
                    </div>
                    <div className={`${isPropertiesCollapsed == true ? "col-sm-1 pe-0" : "col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3"}`} ref={container}>
                        <div className={`props-list d-flex align-items-center justify-content-between pb-3 ${isPropertiesCollapsed == true && "invisible overflow-hidden"}`}>
                            <span className="form-title">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListTitle"] : "Properties"} ({filteredEstates.length})
                            </span>
                            <img src={collapseIcon} onClick={handlerCollapseProperties} />
                        </div>
                        <div className={`${isPropertiesCollapsed == true ? "" : "d-flex flex-row-reverse align-items-center justify-content-between mb-2"}`}>
                            <Dropdown>
                                <Dropdown.Toggle className={`filter-btn filter-btn-estates ${isPropertiesCollapsed == true ? "filter-caret mb-2" : ""}`} id="propertyFilter">
                                    <img src={filterIcon} className="pe-2" />
                                    {
                                        isPropertiesCollapsed == true && (purposeStatusId != "" || displayStatusIds.length > 0 || selectOffice != "") ? "" :
                                            <span className="pe-2">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterBtn"] : "Filter"}</span>
                                    }
                                    {
                                        purposeStatusId != "" || displayStatusIds.length > 0 || selectOffice != "" ?
                                            isPropertiesCollapsed == true ?
                                                <img src={filterCross} className="me-2" onClick={handlerClearEstateFilter} />
                                                :
                                                <button className="clear-btn" onClick={handlerClearEstateFilter}>
                                                    {reduxLanguageTranslations ? reduxLanguageTranslations["clearFilterButtonLabel"] : "Clear"}
                                                    <img src={whiteCross} />
                                                </button>
                                            //<img src={clearCross} className="me-1" onClick={handlerClearEstateFilter} />
                                            :
                                            ""
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="estate-filter-dd">
                                    <div className="form-group">
                                        <label className="form-group-label mt-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOfficeLbl"] : "Office"}</label>
                                        <select className="form-select filter-select mb-2" id="officeList" value={selectOffice} onChange={changehandlerSelectOfficeFilter}>
                                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOfficeOption"] : "Select Office"}</option>
                                            {
                                                officeList.length > 0 ? officeList.map((item, index) => {
                                                    return (
                                                        /*<option value={item.Id} key={index}>{item.Name}</option>*/
                                                        <option value={item.id || item.Id} key={index}>{item.name || item.Name}</option>
                                                    )
                                                })
                                                    :
                                                    <></>
                                            }
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-group-label mt-0">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusLbl"] : "Purpose Status"}</label>
                                        <select className="form-select filter-select mb-2" value={purposeStatusId} onChange={changeHandlerPurposeStatusFilter}>
                                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusOptionSelect"] : "Select Purpose Status"}</option>
                                            <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusSale"] : "For sale"}</option>
                                            <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusRent"] : "For rent"}</option>
                                            <option value="3">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusAnnuitySale"] : "Life annuity sale"}</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-group-label mt-0">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterDisplayStatusLbl"] : "Display Status"}</label>

                                        <MultiSelect
                                            id="displayStatusId"
                                            value={displayStatusIds.length > 0 ? displayStatusIds : []}
                                            options={displayStatusOptions}
                                            onChange={changeHandlerDisplayStatusFilter}
                                            labelledBy="Select Display Status"
                                            className="filter-select"
                                            overrideStrings={customMultiSelectLabels}
                                        />
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                            <div className={`position-relative ${isPropertiesCollapsed == true ? "mb-2" : "me-2"}`}>
                                <input type="search" className="form-control search-box" placeholder={reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListPlaceHolderEstate"] : "Search by estate Id"} value={estateId} onChange={changeHandlerSearchByEstateId} />
                                <FontAwesomeIcon icon={faMagnifyingGlass} className={`search-icon`} />
                            </div>
                        </div>
                        <div className="position-relative mb-2">
                            <input type="search" className="form-control search-box me-2" placeholder={reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListPlaceHolderStreetNo"] : "Search by street, number, city, zip or price"} value={estateSearch} onChange={changeHandlerSearchByEstateProps} />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
                        </div>
                        <div className={`${isPropertiesCollapsed == true ? "form-container form-container-collapsed" : "prop-container"}`} style={{ height: `${isPropertiesCollapsed == true ? "auto" : "83.5vh"}` }}>
                            <img src={expandIcon} className={`${isPropertiesCollapsed == true ? "d-block m-auto mb-3" : "d-none"}`} onClick={handlerCollapseProperties} />
                            <div className={`${isPropertiesCollapsed == true ? "collapsed-properties-scroll" : ""}`} style={{ height: `${isPropertiesCollapsed == true ? "83.5vh" : "auto"}` }}>

                                <div className={`p-3 text-center ${showPropertiesLoader ? "" : "d-none"}`}>
                                    <img src={calLoader} className={`cal-loader`} />
                                </div>
                                {
                                    filteredEstates.length > 0 ? filteredEstates.map((item, index) => {

                                        const isFound = selectedProperty != null && selectedProperty.id != undefined && item.id == selectedProperty.id ? true : false;

                                        var selectedClass = isFound == true ? "selected" : "";

                                        let isFreeSlotExistForEstate = false;
                                        let isEstateFutureOrPastFreeSlot = false;
                                        let isConfigsSaved = false;

                                        let isActivatedInDb = activatedEstates.includes(item.id);
                                        //let isSuspended = suspendedEstates.includes(item.id);

                                        if (estateIdsHavingConfiguration.length > 0 && estateIdsHavingConfiguration.includes(item.id)) {
                                            isConfigsSaved = true;
                                        }

                                        if (estateListContainEvent.length > 0) {
                                            isFreeSlotExistForEstate = estateListContainEvent.indexOf(item.id) >= 0 ? true : false;
                                        }

                                        if (estateIdsHavingFreeSlotsInFutureOrPast.length > 0) {
                                            isEstateFutureOrPastFreeSlot = estateIdsHavingFreeSlotsInFutureOrPast.indexOf(item.id) >= 0 ? true : false;
                                        }

                                        // flow to estate status and estate job status show the button (active, deactive or onhold)
                                        let estateJobActionBtn = estateJobStatusBtn != null ? estateJobStatusBtn.identification : null;
                                        let estateJobActionUI = estateJobStatusBtn != null ? estateJobStatusBtn.jobProcessStatus : null;

                                        if (isPropertiesCollapsed == true) {
                                            let propertyImage = placeholderSmall;
                                            if (item.pictures != undefined && item.pictures.length > 0) {
                                                propertyImage = item.pictures[0].urlSmall;
                                            }
                                            return (
                                                <OverlayTrigger key={index} delay={{ hide: 0, show: 300 }} trigger="click" rootClose placement="left" x-placement="left"
                                                    overlay={(props) => (
                                                        <Tooltip className="prop-tooltip" {...props}>
                                                            <div className={`form-container position-relative form-container-expanded ${selectedClass}`}>
                                                                <div className="prop-img-container position-relative">
                                                                    {
                                                                        item.price != undefined ?
                                                                            <span className="price-tag">{formatPrice(item.price, item.currency)}</span>
                                                                            :
                                                                            ""
                                                                    }
                                                                    <a href={`${variables.Booking_URL}${item.id}`} className={`btn-booking ${reduxEstateStatusList?.[item.id] == "Active" || ((reduxEstateStatusList?.[item.id] == "Pending" || reduxEstateStatusList?.[item.id]?.toLowerCase() == "onhold" || reduxEstateStatusList?.[item.id]?.toLowerCase() == "start") && waitingListEnabled) ? "" : "d-none"}`} target="_blank">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListBookingLink"] : "Booking"}</a>
                                                                    <img src={propertyImage} className="property-img" />
                                                                    <span className="suspended-tag">{reduxEstateStatusList?.[item.id] || ""}</span>
                                                                </div>
                                                                <div className="property-name mt-3">
                                                                    <span>{item.name} ({item.id})</span>
                                                                    <span className="add-slot-link" onClick={handlerAddSlot}>
                                                                        <img src={plusBlueIcon} className="me-2" /> {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListAddSlotBtn"] : "Add Slot"}
                                                                    </span>
                                                                </div>

                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <div className="prop-address my-2">
                                                                        {/*<img src={locationPin} className="me-2" />*/}
                                                                        <p className="mb-0">
                                                                            {
                                                                                (item.address == undefined ? "" : item.address) + " " +
                                                                                (item.number == undefined ? "" : item.number) + ""
                                                                            }
                                                                        </p>
                                                                        <p className="mb-0">
                                                                            {
                                                                                (item.zip == undefined ? "" : item.zip) + " " +
                                                                                (item.city == undefined ? "" : item.city)
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                    <Dropdown className="estate-drop-menu" show={openDropdownId === item.id} onClick={(e) => handleDropdownToggle(e, item.id, item)}>
                                                                        <Dropdown.Toggle className="estate-toggle-menu" variant="light" id={`dropdown-basic${item.id}`}>
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} className="color-blue" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className="text-center p-0">
                                                                            {/*{*/}
                                                                            {/*    estateJobActionBtn != null && estateJobActionBtn?.toLowerCase() == "active" ?*/}
                                                                            {/*        <button className={`drop-menu-btn text-start`} onClick={(e) => markEstateActiveInDB(item)}>{reduxLanguageTranslations ? reduxLanguageTranslations["activateEstateInDatabase"] : "Activate"}</button>*/}
                                                                            {/*        : estateJobActionBtn != null && estateJobActionBtn?.toLowerCase() == "deactivate" ?*/}
                                                                            {/*            <button className={`drop-menu-btn text-start`} onClick={estateJobActionUI ? (e) => markEstateDeactiveInDB(item) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"] : "Deactivate"}</button>*/}
                                                                            {/*            : estateJobActionBtn != null && estateJobActionBtn?.toLowerCase() == "onhold" ?*/}
                                                                            {/*                <button className={`drop-menu-btn text-start`} onClick={estateJobActionUI ? (e) => markEstateDeactiveInDB(item) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["onHold"] : "OnHold"}</button>*/}
                                                                            {/*                :*/}
                                                                            {/*                <></>*/}
                                                                            {/*}*/}
                                                                            {/*<hr className={`mx-2 my-0 ${isFreeSlotExistForEstate || isEstateFutureOrPastFreeSlot || isConfigsSaved ? "" : "d-none"}`} />*/}
                                                                            {/*<button className={`drop-menu-btn text-start ${estateStatusListFromDB[item.id] == "Active" || (estateStatusListFromDB[item.id] == "Pending" && waitingListEnabled) || (estateStatusListFromDB[item.id]?.toLowerCase() == "onhold" && waitingListEnabled) ? "" : "d-none"}`} onClick={() => copToClipBoard(`${variables.Booking_URL}${item.id}`)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListCopyLink"] : "Copy booking link"}</button>*/}
                                                                            {/*<hr className={`mx-2 my-0 ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} />*/}
                                                                            {/*<button className={`drop-menu-btn text-start ${estateStatusListFromDB[item.id] == "Active" ? "" : "d-none"}`} onClick={(e) => handleDeleteAllFreeSlotsClick(e, item.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListDeleteFreeSlot"] : "Delete all free slots"}</button>*/}
                                                                            {/*<hr className={`mx-2 my-0 ${isEstateFutureOrPastFreeSlot && isConfigsSaved ? "" : "d-none"}`} />*/}
                                                                            {/*<button className={`drop-menu-btn text-start ${isConfigsSaved == true ? "" : "d-none"}`}*/}
                                                                            {/*    onClick={(e) => editEstateConfigurations(e, item.id)}>*/}
                                                                            {/*    {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListEditForm"] : "Edit Form"}*/}
                                                                            {/*</button>*/}
                                                                            {/*<button className={`drop-menu-btn text-start`} onClick={waitListBtnEnabled ? () => showContactWaitingListModal(item.id) : undefined}>*/}
                                                                            {/*    {waitListBtnEnabled ? reduxLanguageTranslations ? reduxLanguageTranslations["showContactListBtn"] : "Contact list" : reduxLanguageTranslations ? reduxLanguageTranslations["noContact"] : "No Contact"}*/}
                                                                            {/*</button>*/}

                                                                            <EstateActionListMenu
                                                                                estate={item}
                                                                                identity={"calendar"}
                                                                                showMessage={showMessage}
                                                                                setShowCalendarLoader={setShowCalendarLoader}
                                                                                getWhiseCalenderEvents={getWhiseCalenderEvents}
                                                                                reduxCalendarView={reduxCalendarView}
                                                                            />
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                                <div className="row prop-detail-row mt-3">
                                                                    <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                                        <img src={bedIcon} className={`${item.bedRooms != undefined ? "me-1" : ""}`} />
                                                                        <span className="smallImgIcon-Modal-info">
                                                                            {
                                                                                item.bedRooms != undefined ?
                                                                                    item.bedRooms
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                                        <img src={showerIcon} className={`${item.bathRooms != undefined ? "me-1" : ""}`} />
                                                                        <span className="smallImgIcon-Modal-info">
                                                                            {
                                                                                item.bathRooms != undefined ?
                                                                                    item.bathRooms
                                                                                    :
                                                                                    <></>
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-4 d-flex align-items-center justify-content-center">
                                                                        <img src={liftIcon} className={`${item.area != undefined ? "me-1" : ""}`} />
                                                                        {
                                                                            item.area != undefined ?
                                                                                <span className="smallImgIcon-Modal-info">{item.area}<span className="ms-05">m</span><sup>2</sup></span>
                                                                                :
                                                                                <></>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Tooltip>
                                                    )}>
                                                    <div className={`mb-3 overflow-hidden ${selectedClass}`} onClick={(e) => handlerPropertyClick(item)} id={item.id}>
                                                        <img src={propertyImage} className="sm-prop-img" />
                                                    </div>
                                                </OverlayTrigger>
                                            )
                                        }
                                        else {
                                            let propertyImage = placeholderLarge;
                                            if (item.pictures != undefined && item.pictures.length > 0) {
                                                propertyImage = item.pictures[0].urlLarge;
                                            }
                                            return (
                                                <div className={`form-container position-relative form-container-expanded expanded-estates mb-3 ${selectedClass}`} key={index} onClick={(e) => handlerPropertyClick(item)}>
                                                    <div className="prop-img-container position-relative">
                                                        {
                                                            item.price != undefined ?
                                                                <span className="price-tag">{formatPrice(item.price, item.currency)}</span>
                                                                :
                                                                ""
                                                        }
                                                        {/* href={`${variables.Booking_URL}${item.id}/${clientId}/${item.officeId ? item.officeId : officeId}*/}
                                                        <a href={`${variables.Booking_URL}${item.id}`} className={`btn-booking ${reduxEstateStatusList?.[item.id] == "Active" || ((reduxEstateStatusList?.[item.id] == "Pending" || reduxEstateStatusList?.[item.id]?.toLowerCase() == "onhold" || reduxEstateStatusList?.[item.id]?.toLowerCase() == "start") && waitingListEnabled) ? "" : "d-none"}`} target="_blank">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListBookingLink"] : "Booking"}</a>
                                                        <img src={propertyImage} className="property-img" />
                                                        <span className="suspended-tag">{reduxEstateStatusList?.[item.id] || ""}</span>
                                                    </div>
                                                    <div className="property-name mt-3">
                                                        <span>{item.name} ({item.id})</span>
                                                        <span className="add-slot-link" onClick={handlerAddSlot}>
                                                            <img src={plusBlueIcon} className="me-2" /> {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListAddSlotBtn"] : "Add Slot"}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="prop-address my-2">
                                                            {/*<img src={locationPin} className="me-2" />*/}
                                                            <p className="mb-0">
                                                                {
                                                                    (item.address == undefined ? "" : item.address) + " " +
                                                                    (item.number == undefined ? "" : item.number) + ""
                                                                }
                                                            </p>
                                                            <p className="mb-0">
                                                                {
                                                                    (item.zip == undefined ? "" : item.zip) + " " +
                                                                    (item.city == undefined ? "" : item.city)
                                                                }
                                                            </p>
                                                        </div>
                                                        <Dropdown className="estate-drop-menu" show={openDropdownId === item.id} onClick={(e) => handleDropdownToggle(e, item.id, item)}>
                                                            <Dropdown.Toggle className="estate-toggle-menu" variant="light" id="dropdown-basic">
                                                                <FontAwesomeIcon icon={faEllipsisVertical} className="color-blue" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className="text-center p-0">
                                                                {/*{*/}
                                                                {/*    estateJobActionBtn != null && estateJobActionBtn?.toLowerCase() == "active" ?*/}
                                                                {/*        <button className={`drop-menu-btn text-start`} onClick={(e) => markEstateActiveInDB(item)}>{reduxLanguageTranslations ? reduxLanguageTranslations["activateEstateInDatabase"] : "Activate"}</button>*/}
                                                                {/*        : estateJobActionBtn != null && estateJobActionBtn?.toLowerCase() == "deactivate" ?*/}
                                                                {/*            <button className={`drop-menu-btn text-start`} onClick={estateJobActionUI ? (e) => markEstateDeactiveInDB(item) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"] : "Deactivate"}</button>*/}
                                                                {/*            : estateJobActionBtn != null && estateJobActionBtn?.toLowerCase() == "onhold" ?*/}
                                                                {/*                <button className={`drop-menu-btn text-start`} onClick={estateJobActionUI ? (e) => markEstateDeactiveInDB(item) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["onHold"] : "OnHold"}</button>*/}
                                                                {/*                :*/}
                                                                {/*                <></>*/}
                                                                {/*}*/}
                                                                {/*<hr className={`mx-2 my-0 ${isFreeSlotExistForEstate || isEstateFutureOrPastFreeSlot || isConfigsSaved ? "" : "d-none"}`} />*/}
                                                                {/*<button className={`drop-menu-btn text-start ${estateStatusListFromDB[item.id] == "Active" || (estateStatusListFromDB[item.id] == "Pending" && waitingListEnabled) || (estateStatusListFromDB[item.id]?.toLowerCase() == "onhold" && waitingListEnabled) ? "" : "d-none"}`} onClick={() => copToClipBoard(`${variables.Booking_URL}${item.id}`)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListCopyLink"] : "Copy booking link"}</button>*/}
                                                                {/*<hr className={`mx-2 my-0 ${isFreeSlotExistForEstate == true ? "" : "d-none"}`} />*/}
                                                                {/*<button className={`drop-menu-btn text-start ${estateStatusListFromDB[item.id] == "Active" ? "" : "d-none"}`} onClick={(e) => handleDeleteAllFreeSlotsClick(e, item.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListDeleteFreeSlot"] : "Delete all free slots"}</button>*/}
                                                                {/*<hr className={`mx-2 my-0 ${isEstateFutureOrPastFreeSlot && isConfigsSaved ? "" : "d-none"}`} />*/}
                                                                {/*<button className={`drop-menu-btn text-start ${isConfigsSaved == true ? "" : "d-none"}`}*/}
                                                                {/*    onClick={(e) => editEstateConfigurations(e, item.id)}>*/}
                                                                {/*    {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListEditForm"] : "Edit Form"}*/}
                                                                {/*</button>*/}
                                                                {/*<button className={`drop-menu-btn text-start`} onClick={waitListBtnEnabled ? () => showContactWaitingListModal(item.id) : undefined}>*/}
                                                                {/*    {waitListBtnEnabled ? reduxLanguageTranslations ? reduxLanguageTranslations["showContactListBtn"] : "Contact list" : reduxLanguageTranslations ? reduxLanguageTranslations["noContact"] : "No Contact"}*/}
                                                                {/*</button>*/}

                                                                <EstateActionListMenu
                                                                    estate={item}
                                                                    identity={"calendar"}
                                                                    showMessage={showMessage}
                                                                    setShowCalendarLoader={setShowCalendarLoader}
                                                                    getWhiseCalenderEvents={getWhiseCalenderEvents}
                                                                    reduxCalendarView={reduxCalendarView}
                                                                />
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <div className="row prop-detail-row mt-3">
                                                        <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                            <img src={bedIcon} className={`${item.bedRooms != undefined ? "me-1" : ""}`} />
                                                            <span className="smallImgIcon-Modal-info">
                                                                {
                                                                    item.bedRooms != undefined ?
                                                                        item.bedRooms
                                                                        :
                                                                        <></>
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                            <img src={showerIcon} className={`${item.bathRooms != undefined ? "me-1" : ""}`} />
                                                            <span className="smallImgIcon-Modal-info">
                                                                {
                                                                    item.bathRooms != undefined ?
                                                                        item.bathRooms
                                                                        :
                                                                        <></>
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-4 d-flex align-items-center justify-content-center">
                                                            <img src={liftIcon} className={`${item.area != undefined ? "me-1" : ""}`} />
                                                            {
                                                                item.area != undefined ?
                                                                    <span className="smallImgIcon-Modal-info">{item.area}<span className="ms-05">m</span><sup>2</sup></span>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                        :
                                        <></>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmDeleteWindow showConfirmWindow={showConfirmWindow} handleConfirmWindowClose={handleConfirmWindowClose} callBackConfirmDeleteFreeSlots={callBackConfirmDeleteFreeSlots} displayMessage={confirmWindowMessage} />
            <EventModal showModal={showModal} handleCloseModal={handleClose} showMessage={showMessage} whiseAgents={whiseAgents} saveNewWhiseEvent={saveNewWhiseEvent}
                preview={previewEvent} callBackToUpdateCalendarFilter={callBackToUpdateCalendarFilter} previewEventDetail={previewEventDetail}
                tobeConfirmedIds={tobeConfirmedIds} confirmedIds={confirmedIds} freeSlotIds={freeSlotIds} deleteWhiseCalendarEvent={deleteWhiseCalendarEvent}
                acceptToBeConfirmedEvents={acceptToBeConfirmedEvents} isEstateConfigurationsEdit={isEstateConfigurationsEdit} getEstateIdsHavingConfigSaved={getEstateIdsHavingConfigSaved}
                setIsLocalDbEventToBeDeleted={setIsLocalDbEventToBeDeleted} officeSettings={officeSettings} automaticSlotAccept={automaticSlotAccept}
                setAutomaticSlotAccept={setAutomaticSlotAccept}
            />
            <ContactWaitingListModel
                estate={reduxProperty}
                onHide={() => setContactWaitinglistModalShow(false)}
            />
            <EstateJobActionModel showModel={showEstateJobActionModel} closeModel={closeModelEstateJobActions} clientId={clientId}
                estate={selectedProperty} officeId={officeId}
            />
        </>
    )
}